<template>
  <div>
    <div class="main-content p-1" v-if="loader >= 100">
      <div class="row">
        <div class="col-9">
          <div
            class="card h-100"
            :style="'border-left: 8px solid ' + senha.classificacao.cor + ';'"
          >
            <div class="card-body">
              <div class="row">
                <div
                  class="d-flex justify-content-between flex-column col-xl-7 col-12"
                >
                  <div class="row">
                    <div
                      class="d-flex justify-content-center align-items-center"
                      style="flex-direction: column"
                    >
                      <div
                        class="d-flex justify-content-center align-items-center"
                        :style="'width :' + (img + 50) + 'px;'"
                      >
                        <span
                          class="b-avatar badge-light-danger rounded avatar"
                          :style="
                            'min-width:' + img + 'px; height:' + img + 'px;'
                          "
                        >
                          <span class="b-avatar-img">
                            <img
                              :src="pessoa.foto"
                              alt="avatar"
                              class="clocks"
                              v-if="
                                senha.min_atendimento.pessoa_id && pessoa.foto
                              "
                              data-toggle="modal"
                              data-target="#getFoto"
                              @click="iniciarCamera()"
                            />
                            <img
                              src="@/assets/images/avatars/default.png"
                              alt="avatar"
                              class="clocks"
                              data-toggle="modal"
                              data-target="#getFoto"
                              @click="iniciarCamera()"
                              v-else
                            />
                          </span>
                        </span>
                      </div>
                      <div
                        class="modal fade"
                        id="getFoto"
                        tabindex="-1"
                        role="dialog"
                        aria-labelledby="getFotoLabel"
                        aria-hidden="true"
                      >
                        <div class="modal-dialog" role="document">
                          <div class="modal-content">
                            <div class="modal-header bg-primary">
                              <h5
                                class="modal-title"
                                style="color: #eee"
                                id="getFotoLabel"
                              >
                                Cadastramento facial
                              </h5>
                              <button
                                type="button"
                                class="close"
                                data-dismiss="modal"
                                aria-label="Close"
                              >
                                <span aria-hidden="true">&times;</span>
                              </button>
                            </div>
                            <div class="modal-body">
                              <div class="row">
                                <div class="col-md-12 mt-1">
                                  <label>CPF*</label>
                                  <div class="input-group">
                                    <input
                                      type="text"
                                      class="form-control"
                                      v-model="pessoa.cpf"
                                      v-mask="'999.999.999-99'"
                                    />
                                    <div class="input-group-append">
                                      <button
                                        class="btn btn-primary"
                                        type="button"
                                        @click="getCpf()"
                                      >
                                        <i class="fas fa-search"></i>
                                      </button>
                                    </div>
                                  </div>
                                </div>
                                <div class="col-12 mt-1">
                                  <label>Nome *</label>
                                  <input
                                    type="text"
                                    class="form-control"
                                    v-model="pessoa.nome_social"
                                  />
                                </div>
                                <div class="col-12">
                                  <label>Nome mãe</label>
                                  <input
                                    type="text"
                                    class="form-control"
                                    v-model="pessoa.nome_mae"
                                  />
                                </div>
                                <div class="col-md-6">
                                  <label>Telefone *</label>
                                  <input
                                    type="text"
                                    class="form-control"
                                    v-model="pessoa.telefone"
                                  />
                                </div>
                                <div class="col-md-6">
                                  <label>Genero *</label>
                                  <select
                                    class="form-control"
                                    v-model="pessoa.sexo"
                                  >
                                    <option :value="'M'">Masculino</option>
                                    <option :value="'F'">Feminino</option>
                                  </select>
                                </div>
                                <div class="col-md-6">
                                  <label>RG</label>
                                  <input
                                    type="text"
                                    class="form-control"
                                    v-model="pessoa.rg"
                                  />
                                </div>
                                <div class="col-md-6">
                                  <label>CNS</label>
                                  <input
                                    type="text"
                                    class="form-control"
                                    v-model="pessoa.cns"
                                  />
                                </div>
                                <div class="col-12">
                                  <label>Email</label>
                                  <input
                                    type="text"
                                    class="form-control"
                                    v-model="pessoa.email"
                                  />
                                </div>
                                <div class="col-12">
                                  <label>Alergias</label>
                                  <input
                                    type="text"
                                    class="form-control"
                                    v-model="pessoa.alergias"
                                  />
                                </div>
                                <div class="col-12">
                                  <label>CEP</label>
                                  <input
                                    type="text"
                                    class="form-control"
                                    v-model="pessoa.cep"
                                    v-mask="'99999-999'"
                                    @input="getEndereco()"
                                  />
                                </div>
                                <div class="col-12">
                                  <label>Logradouro</label>
                                  <input
                                    type="text"
                                    class="form-control"
                                    v-model="pessoa.logradouro"
                                  />
                                </div>
                                <div class="col-md-6">
                                  <label>Número</label>
                                  <input
                                    type="text"
                                    class="form-control"
                                    v-model="pessoa.numero"
                                  />
                                </div>
                                <div class="col-md-6">
                                  <label>Complemento</label>
                                  <input
                                    type="text"
                                    class="form-control"
                                    v-model="pessoa.complemento"
                                  />
                                </div>
                                <div class="col-12">
                                  <label>Bairro</label>
                                  <input
                                    type="text"
                                    class="form-control"
                                    v-model="pessoa.bairro"
                                  />
                                </div>
                                <div class="col-12">
                                  <label>Cidade</label>
                                  <input
                                    type="text"
                                    class="form-control"
                                    v-model="pessoa.cidade"
                                  />
                                </div>
                                <div class="col-12 mb-1">
                                  <label>Estado</label>
                                  <input
                                    type="text"
                                    class="form-control"
                                    v-model="pessoa.estado"
                                  />
                                </div>
                                <div class="col-12">
                                  <video
                                    ref="video"
                                    autoplay
                                    width="100%"
                                  ></video>
                                  <canvas
                                    ref="canvas"
                                    width="640"
                                    height="480"
                                    style="display: none"
                                  ></canvas>
                                </div>
                                <div class="col-12 text-center my-1">
                                  <button
                                    class="btn btn-sm btn-outline-primary"
                                    @click="tirarFoto"
                                  >
                                    Cadastrar
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <!-- Modal -->
                      <div
                        class="modal fade"
                        id="changePrioridade"
                        tabindex="-1"
                        role="dialog"
                        aria-labelledby="changePrioridadeLabel"
                        aria-hidden="true"
                      >
                        <div class="modal-dialog" role="document">
                          <div class="modal-content">
                            <div class="modal-header">
                              <h5
                                class="modal-title"
                                id="changePrioridadeLabel"
                              >
                                Alterar grupo prioritário
                              </h5>
                              <button
                                type="button"
                                class="close"
                                data-dismiss="modal"
                                aria-label="Close"
                              >
                                <span aria-hidden="true">&times;</span>
                              </button>
                            </div>
                            <div class="modal-body">
                              <select v-model="prioridade" class="form-control">
                                <option
                                  :value="0"
                                  :key="0"
                                  :selected="
                                    senha.prioridade === 0 ? 'true' : 'false'
                                  "
                                >
                                  Ausente
                                </option>
                                <option
                                  :value="1"
                                  :key="1"
                                  :selected="
                                    senha.prioridade === 1 ? 'true' : 'false'
                                  "
                                >
                                  Comum
                                </option>
                                <option
                                  :value="2"
                                  :key="2"
                                  :selected="
                                    senha.prioridade === 2 ? 'true' : 'false'
                                  "
                                >
                                  Prioritário
                                </option>
                                <option
                                  :value="3"
                                  :key="3"
                                  :selected="
                                    senha.prioridade === 3 ? 'true' : 'false'
                                  "
                                >
                                  Prioritário +80
                                </option>
                              </select>
                            </div>
                            <div class="modal-footer">
                              <button
                                type="button"
                                class="btn btn-outline-secondary"
                                data-dismiss="modal"
                              >
                                Cancelar
                              </button>
                              <button
                                type="button"
                                class="btn btn-secondary"
                                data-dismiss="modal"
                                @click="changePrioridade"
                              >
                                Confirmar
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="ml-1 ml-sm-0">
                      <div
                        class="modal fade bd-example-modal-lg"
                        id="senhaPath"
                        tabindex="-1"
                        role="dialog"
                        aria-labelledby="modalLg"
                        aria-hidden="true"
                      >
                        <div class="modal-dialog modal-lg" role="document">
                          <div class="modal-content timeline-modal">
                            <div class="modal-header timeline-header">
                              <div class="d-flex align-items-center">
                                <i
                                  class="fas fa-history mr-2"
                                  style="font-size: 24px"
                                ></i>
                                <h5
                                  class="modal-title mb-0"
                                  id="senhaPathTitle"
                                >
                                  Histórico da Senha
                                </h5>
                              </div>
                              <button
                                type="button"
                                class="close"
                                data-dismiss="modal"
                                aria-label="Close"
                              >
                                <span aria-hidden="true">&times;</span>
                              </button>
                            </div>
                            <div class="modal-body timeline-body">
                              <div class="timeline-container">
                                <div
                                  class="timeline-item"
                                  v-for="(atendimento, index) in senhaPath"
                                  :key="atendimento.id"
                                >
                                  <div class="timeline-marker">
                                    <div
                                      class="timeline-icon"
                                      :class="
                                        'timeline-icon-' +
                                        atendimento.status_badge
                                      "
                                    >
                                      <i
                                        class="fas"
                                        :class="getTimelineIcon(atendimento)"
                                      ></i>
                                    </div>
                                    <div
                                      class="timeline-line"
                                      v-if="index < senhaPath.length - 1"
                                    ></div>
                                  </div>
                                  <div class="timeline-content">
                                    <div class="timeline-card">
                                      <div class="timeline-card-header">
                                        <div
                                          class="d-flex justify-content-between align-items-start"
                                        >
                                          <div>
                                            <h6 class="timeline-setor">
                                              <i
                                                class="fas fa-building mr-1"
                                              ></i>
                                              {{ atendimento.setor.nome }}
                                            </h6>
                                            <span
                                              class="timeline-local"
                                              v-if="atendimento.local_id"
                                            >
                                              <i
                                                class="fas fa-map-marker-alt mr-1"
                                              ></i>
                                              {{ atendimento.local.nome }}
                                            </span>
                                          </div>
                                          <span
                                            :class="
                                              'badge badge-' +
                                              atendimento.status_badge +
                                              ' timeline-badge'
                                            "
                                          >
                                            {{ atendimento.status_text }}
                                          </span>
                                        </div>
                                      </div>
                                      <div class="timeline-card-body">
                                        <div class="row">
                                          <div class="col-md-6">
                                            <div class="timeline-info-item">
                                              <i
                                                class="fas fa-user-md mr-2 text-primary"
                                              ></i>
                                              <div>
                                                <small
                                                  class="text-muted d-block"
                                                  >Atendido por</small
                                                >
                                                <span class="font-weight-bold">
                                                  {{
                                                    atendimento.user_id
                                                      ? atendimento.user.name
                                                      : "Não atendido"
                                                  }}
                                                </span>
                                              </div>
                                            </div>
                                          </div>
                                          <div class="col-md-6">
                                            <div class="timeline-info-item">
                                              <i
                                                class="fas fa-clock mr-2 text-success"
                                              ></i>
                                              <div>
                                                <small
                                                  class="text-muted d-block"
                                                  >Tempo de permanência</small
                                                >
                                                <span class="font-weight-bold">
                                                  {{
                                                    atendimento.data_fim_f
                                                      ? atendimento.tempo_total
                                                      : "Em andamento"
                                                  }}
                                                </span>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                        <hr class="my-2" />
                                        <div class="timeline-timestamps">
                                          <div class="timestamp-item">
                                            <i
                                              class="fas fa-sign-in-alt text-info"
                                            ></i>
                                            <div>
                                              <small>Entrada</small>
                                              <span>{{
                                                atendimento.data_entrada_f
                                              }}</span>
                                            </div>
                                          </div>
                                          <div class="timestamp-item">
                                            <i
                                              class="fas fa-play-circle text-warning"
                                            ></i>
                                            <div>
                                              <small>Início</small>
                                              <span>{{
                                                atendimento.data_inicio_f ||
                                                "Não iniciado"
                                              }}</span>
                                            </div>
                                          </div>
                                          <div class="timestamp-item">
                                            <i
                                              class="fas fa-stop-circle text-danger"
                                            ></i>
                                            <div>
                                              <small>Fim</small>
                                              <span>{{
                                                atendimento.data_fim_f ||
                                                "Não finalizado"
                                              }}</span>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <!-- Modal Histórico de Atendimentos da Pessoa -->
                      <div
                        class="modal fade bd-example-modal-lg"
                        id="historicoAtendimentosModal"
                        tabindex="-1"
                        role="dialog"
                        aria-labelledby="historicoAtendimentosModalLabel"
                        aria-hidden="true"
                      >
                        <div class="modal-dialog modal-lg" role="document">
                          <div class="modal-content timeline-modal">
                            <div class="modal-header timeline-header">
                              <div class="d-flex align-items-center">
                                <i
                                  class="fas fa-user-clock mr-2"
                                  style="font-size: 24px"
                                ></i>
                                <h5
                                  class="modal-title mb-0"
                                  id="historicoAtendimentosModalLabel"
                                >
                                  Histórico de Atendimentos - {{ pessoa.nome }}
                                </h5>
                              </div>
                              <button
                                type="button"
                                class="close"
                                data-dismiss="modal"
                                aria-label="Close"
                              >
                                <span aria-hidden="true">&times;</span>
                              </button>
                            </div>
                            <div class="modal-body timeline-body">
                              <div class="text-center" v-if="loadingHistorico">
                                <i
                                  class="fas fa-spinner fa-spin"
                                  style="font-size: 24px"
                                ></i>
                                <p class="mt-2">Carregando histórico...</p>
                              </div>
                              <div
                                class="timeline-container"
                                v-else-if="historicoAtendimentos.length > 0"
                              >
                                <div class="alert alert-info mb-3">
                                  <h6 class="mb-1">
                                    <i class="fas fa-info-circle mr-1"></i>
                                    Resumo dos Atendimentos
                                  </h6>
                                  <p class="mb-0">
                                    Exibindo
                                    <strong>{{
                                      historicoAtendimentos.length
                                    }}</strong>
                                    atendimento(s)
                                    <span v-if="historicoHasMore">
                                      — role para ver mais</span
                                    >
                                  </p>
                                </div>
                                <div
                                  class="timeline-item"
                                  v-for="(
                                    atendimento, index
                                  ) in historicoAtendimentos"
                                  :key="atendimento.id"
                                >
                                  <div class="timeline-marker">
                                    <div
                                      class="timeline-icon timeline-icon-primary"
                                    >
                                      <i class="fas fa-user-md"></i>
                                    </div>
                                    <div
                                      class="timeline-line"
                                      v-if="
                                        index < historicoAtendimentos.length - 1
                                      "
                                    ></div>
                                  </div>
                                  <div class="timeline-content">
                                    <div class="timeline-card">
                                      <div class="timeline-card-header">
                                        <div
                                          class="d-flex justify-content-between align-items-start"
                                        >
                                          <div>
                                            <h6 class="timeline-setor">
                                              <i
                                                class="fas fa-calendar mr-1"
                                              ></i>
                                              {{
                                                atendimento.data_inicio
                                                  ? new Date(
                                                      atendimento.data_inicio
                                                    ).toLocaleDateString(
                                                      "pt-BR"
                                                    )
                                                  : "Data não informada"
                                              }}
                                            </h6>
                                            <span class="timeline-local">
                                              <i class="fas fa-clock mr-1"></i>
                                              {{
                                                atendimento.data_inicio
                                                  ? new Date(
                                                      atendimento.data_inicio
                                                    ).toLocaleTimeString(
                                                      "pt-BR"
                                                    )
                                                  : "Hora não informada"
                                              }}
                                            </span>
                                          </div>
                                          <span
                                            class="badge badge-primary timeline-badge"
                                          >
                                            Atendimento #{{ atendimento.id }}
                                          </span>
                                        </div>
                                      </div>
                                      <div class="timeline-card-body">
                                        <div class="row">
                                          <div class="col-md-6">
                                            <div class="timeline-info-item">
                                              <i
                                                class="fas fa-mouse-pointer mr-2 text-primary"
                                              ></i>
                                              <div>
                                                <small
                                                  class="text-muted d-block"
                                                  >Demanda</small
                                                >
                                                <span class="font-weight-bold">
                                                  {{
                                                    atendimento.botao &&
                                                    atendimento.botao.nome
                                                      ? atendimento.botao.nome
                                                      : "Não informado"
                                                  }}
                                                </span>
                                              </div>
                                            </div>
                                          </div>
                                          <div class="col-md-6">
                                            <div class="timeline-info-item">
                                              <i
                                                class="fas fa-info-circle mr-2 text-info"
                                              ></i>
                                              <div>
                                                <small
                                                  class="text-muted d-block"
                                                  >Status</small
                                                >
                                                <span class="font-weight-bold">
                                                  {{
                                                    atendimento.data_fim
                                                      ? "Finalizado"
                                                      : atendimento.data_inicio
                                                      ? "Iniciado"
                                                      : "Aguardando"
                                                  }}
                                                </span>
                                              </div>
                                            </div>
                                          </div>
                                        </div>
                                        <hr class="my-2" />
                                        <div class="timeline-timestamps">
                                          <div
                                            class="timestamp-item"
                                            v-if="atendimento.data_inicio"
                                          >
                                            <i
                                              class="fas fa-play-circle text-warning"
                                            ></i>
                                            <div>
                                              <small>Iniciado</small>
                                              <span>{{
                                                atendimento.data_inicio
                                              }}</span>
                                            </div>
                                          </div>
                                          <div
                                            class="timestamp-item"
                                            v-if="atendimento.data_fim"
                                          >
                                            <i
                                              class="fas fa-check-circle text-success"
                                            ></i>
                                            <div>
                                              <small>Finalizado</small>
                                              <span>{{
                                                atendimento.data_fim
                                              }}</span>
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <!-- Indicador de carregando mais -->
                              <div
                                class="text-center py-3"
                                v-if="historicoCarregandoMais"
                              >
                                <i class="fas fa-spinner fa-spin"></i>
                                <span class="ml-2">Carregando mais...</span>
                              </div>
                              <div
                                class="text-center py-4"
                                v-else-if="
                                  !loadingHistorico &&
                                  !historicoAtendimentos.length
                                "
                              >
                                <i
                                  class="fas fa-search"
                                  style="font-size: 48px; color: #ddd"
                                ></i>
                                <h6 class="mt-3 text-muted">
                                  Nenhum atendimento encontrado
                                </h6>
                                <p class="text-muted">
                                  Esta pessoa ainda não possui histórico de
                                  atendimentos.
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <h4 class="mt-0 mb-1">
                        <span>
                          {{
                            pessoa.nome_social ? pessoa.nome : "Não informado"
                          }}
                        </span>
                        <button
                          class="btn btn-crud btn-outline-secondary ml-2"
                          title="Histórico de atendimentos"
                          data-toggle="modal"
                          data-target="#historicoAtendimentosModal"
                          @click="getHistoricoPessoa()"
                        >
                          <i class="fas fa-history"></i>
                        </button>
                      </h4>

                      <span
                        class="card-text d-block mb-2"
                        style="color: #6e6b7b; font-size: 14px"
                      >
                        {{ pessoa.diffIdade }}
                      </span>

                      <div class="d-flex flex-column align-items-start">
                        <button
                          class="btn btn-outline-secondary btn-sm mb-2"
                          @click="pessoaModal()"
                          style="min-width: 160px"
                        >
                          <i class="fas fa-user-edit mr-1"></i>
                          Editar Informações
                        </button>

                        <button
                          v-if="
                            senha.min_atendimento &&
                            senha.min_atendimento.respostas_questionario &&
                            senha.min_atendimento.respostas_questionario.length
                          "
                          class="btn btn-outline-secondary btn-sm mb-2"
                          data-toggle="modal"
                          data-target="#questionarioModal"
                          style="min-width: 160px"
                        >
                          <i class="fas fa-notes-medical mr-1"></i>
                          Respostas do questionário
                        </button>

                        <span
                          class="badge-prioridade"
                          v-html="senha.prioridade_badge"
                          data-toggle="modal"
                          data-target="#changePrioridade"
                          v-if="atual.prioridade"
                          style="cursor: pointer"
                        ></span>
                        <span
                          class="badge-prioridade-disabled"
                          v-html="senha.prioridade_badge"
                          v-else
                        ></span>
                      </div>
                    </div>
                  </div>
                  <div
                    class="modal fade"
                    id="pessoaModal"
                    tabindex="-1"
                    role="dialog"
                    aria-labelledby="title"
                    aria-hidden="true"
                  >
                    <div class="modal-dialog" role="document">
                      <div class="modal-content">
                        <div class="modal-header">
                          <h5 class="modal-title" id="title">
                            Informações do {{ configuracao.tipo_pessoa }}
                          </h5>
                          <button
                            type="button"
                            class="close"
                            data-dismiss="modal"
                            aria-label="Close"
                          >
                            <span aria-hidden="true">&times;</span>
                          </button>
                        </div>
                        <div class="modal-body text-left">
                          <div class="row">
                            <div class="col-md-12">
                              <h6><b>Documentos:</b></h6>
                            </div>
                            <div class="col-md-12 mb-1">
                              <label>CPF</label>
                              <div class="input-group">
                                <input
                                  type="text"
                                  class="form-control"
                                  v-model="pessoa.cpf"
                                  v-mask="'999.999.999-99'"
                                />
                                <div class="input-group-append">
                                  <button
                                    class="btn btn-outline-secondary"
                                    type="button"
                                    @click="getCpf()"
                                  >
                                    <i class="fas fa-search"></i>
                                  </button>
                                </div>
                              </div>
                            </div>
                            <div
                              class="col-md-12 mb-1"
                              v-show="configuracao.cns == 1"
                            >
                              <label>CNS</label>
                              <input
                                type="text"
                                class="form-control"
                                maxlength="200"
                                v-model="pessoa.cns"
                              />
                            </div>
                            <div class="col-md-12 mt-1">
                              <h6>
                                <b>Filiação (biológica):</b>
                              </h6>
                            </div>
                            <div class="col-md-12">
                              <label>Nome do pai</label>
                              <input
                                type="text"
                                class="form-control"
                                maxlength="200"
                                v-model="pessoa.nome_pai"
                              />
                            </div>
                            <div class="col-md-12">
                              <label>Nome da mãe</label>
                              <input
                                type="text"
                                class="form-control"
                                maxlength="200"
                                v-model="pessoa.nome_mae"
                              />
                            </div>
                            <div class="col-md-12 mt-1">
                              <h6><b>Informações pessoais:</b></h6>
                            </div>
                            <div class="col-md-12">
                              <label>Nome</label>
                              <input
                                type="text"
                                class="form-control"
                                maxlength="200"
                                v-model="pessoa.nome"
                              />
                            </div>
                            <div class="col-md-12">
                              <label>Nome Social</label>
                              <input
                                type="text"
                                class="form-control"
                                maxlength="200"
                                v-model="pessoa.nome_social"
                              />
                            </div>
                            <div class="col-12">
                              <label>CEP</label>
                              <input
                                type="text"
                                class="form-control"
                                v-model="pessoa.cep"
                                v-mask="'99999-999'"
                                @input="getEndereco()"
                              />
                            </div>
                            <div class="col-12">
                              <label>Logradouro</label>
                              <input
                                type="text"
                                class="form-control"
                                v-model="pessoa.logradouro"
                              />
                            </div>
                            <div class="col-md-6">
                              <label>Número</label>
                              <input
                                type="text"
                                class="form-control"
                                v-model="pessoa.numero"
                              />
                            </div>
                            <div class="col-md-6">
                              <label>Complemento</label>
                              <input
                                type="text"
                                class="form-control"
                                v-model="pessoa.complemento"
                              />
                            </div>
                            <div class="col-12">
                              <label>Bairro</label>
                              <input
                                type="text"
                                class="form-control"
                                v-model="pessoa.bairro"
                              />
                            </div>
                            <div class="col-12">
                              <label>Cidade</label>
                              <input
                                type="text"
                                class="form-control"
                                v-model="pessoa.cidade"
                              />
                            </div>
                            <div class="col-12 mb-1">
                              <label>Estado</label>
                              <input
                                type="text"
                                class="form-control"
                                v-model="pessoa.estado"
                              />
                            </div>
                            <div class="col-md-4 mb-1">
                              <label><b>Data de nascimento</b></label>
                              <input
                                type="date"
                                class="form-control"
                                v-model="pessoa.data_nascimento_form"
                              />
                            </div>
                            <div class="col-md-4 mb-1">
                              <label><b>Telefone</b></label>
                              <input
                                type="text"
                                class="form-control"
                                maxlength="200"
                                v-model="pessoa.telefone"
                                v-mask="'(99) 99999-9999'"
                              />
                            </div>
                            <div class="col-md-4 mb-1">
                              <label><b>Sexo</b></label>
                              <select
                                v-model="pessoa.sexo"
                                class="text-center form-control"
                              >
                                <option :value="'M'">Masculino</option>
                                <option :value="'F'">Feminino</option>
                              </select>
                            </div>
                          </div>
                        </div>
                        <div class="modal-footer">
                          <button
                            type="button"
                            class="btn btn-outline-secondary"
                            data-dismiss="modal"
                          >
                            Cancelar
                          </button>
                          <button
                            type="button"
                            class="btn btn-secondary"
                            data-dismiss="modal"
                            @click="savePessoa()"
                          >
                            Confirmar
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    class="modal fade"
                    id="questionarioModal"
                    tabindex="-1"
                    role="dialog"
                    aria-labelledby="questionarioModalLabel"
                    aria-hidden="true"
                  >
                    <div class="modal-dialog" role="document">
                      <div class="modal-content">
                        <div class="modal-header">
                          <h5 class="modal-title" id="questionarioModalLabel">
                            Respostas do questionário
                          </h5>
                          <button
                            type="button"
                            class="close"
                            data-dismiss="modal"
                            aria-label="Close"
                          >
                            <span aria-hidden="true">&times;</span>
                          </button>
                        </div>
                        <div class="modal-body">
                          <template v-if="respostasDoQuestionario.length">
                            <div
                              v-for="(linha, indice) in respostasDoQuestionario"
                              :key="indice"
                              class="mb-2"
                            >
                              <p class="mb-1">
                                <strong>{{ linha.pergunta }}</strong>
                              </p>
                              <ul class="mb-0">
                                <li
                                  v-for="(resposta, posicao) in linha.respostas"
                                  :key="posicao"
                                >
                                  {{ resposta }}
                                </li>
                              </ul>
                            </div>
                          </template>
                          <template v-else>
                            <p class="mb-0 text-muted">
                              Nenhuma resposta informada.
                            </p>
                          </template>

                          <div
                            class="alert alert-light mt-3 mb-0"
                            v-if="linhasCuidadoSugeridas.length"
                          >
                            <p class="mb-1">
                              <strong>Linha de cuidado sugerida pelas respostas</strong>
                            </p>
                            <ul class="mb-1">
                              <li
                                v-for="(sugestao, indice) in linhasCuidadoSugeridas"
                                :key="indice"
                              >
                                {{ sugestao.linha_cuidado }}
                              </li>
                            </ul>
                            <small class="text-muted">
                              Sugestão a partir do que o paciente respondeu no totem. A
                              confirmação é da triagem.
                            </small>
                          </div>
                        </div>
                        <div class="modal-footer">
                          <button
                            type="button"
                            class="btn btn-outline-secondary"
                            data-dismiss="modal"
                          >
                            Fechar
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-xl-5 col-12">
                  <table class="mt-2 mt-xl-0 w-100">
                    <tr>
                      <th class="pb-50">
                        <i class="fas fa-venus-mars mr-75"></i>
                        <span class="font-weight-bold">Sexo</span>
                      </th>
                      <td class="pb-50">
                        {{
                          pessoa.sexo
                            ? pessoa.sexo === "M"
                              ? "Masculino"
                              : "Feminino"
                            : "Não Informado"
                        }}
                      </td>
                    </tr>
                    <tr>
                      <th class="pb-50">
                        <i class="fas fa-id-card mr-75"></i>
                        <span class="font-weight-bold">CNS</span>
                      </th>
                      <td class="pb-50 text-capitalize">
                        {{ pessoa.cns ? pessoa.cns : "Não informado" }}
                      </td>
                    </tr>
                    <tr>
                      <th class="pb-50">
                        <i class="fas fa-calendar-alt mr-75"></i>
                        <span class="font-weight-bold">Nascimento</span>
                      </th>
                      <td class="pb-50 text-capitalize">
                        <span
                          :style="
                            new Date().getDate() ===
                              new Date(pessoa.data_nascimento).getDate() &&
                            new Date().getMonth() ===
                              new Date(pessoa.data_nascimento).getMonth()
                              ? 'color: #d41089 !important;'
                              : ''
                          "
                        >
                          <i
                            class="fas fa-birthday-cake"
                            v-if="
                              new Date().getDate() ===
                                new Date(pessoa.data_nascimento).getDate() &&
                              new Date().getMonth() ===
                                new Date(pessoa.data_nascimento).getMonth()
                            "
                          ></i>
                          {{
                            pessoa.data_nascimento
                              ? pessoa.data_nascimento_f
                              : "Não informado"
                          }}
                        </span>
                      </td>
                    </tr>
                    <tr>
                      <th class="pb-50 text-capitalize">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="14px"
                          height="14px"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                          class="mr-75 feather feather-phone"
                        >
                          <path
                            d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"
                          ></path>
                        </svg>
                        <span class="font-weight-bold">Telefone</span>
                      </th>
                      <td class="pb-50 text-capitalize">
                        {{
                          pessoa.telefone ? pessoa.telefone : "Não informado"
                        }}
                      </td>
                    </tr>
                    <tr>
                      <th>
                        <i class="fas fa-file mr-75"></i>
                        <span class="font-weight-bold"> Episódio</span>
                      </th>
                      <td>
                        <div class="d-flex align-items-center">
                          {{
                            senha.min_atendimento.externo_id
                              ? senha.min_atendimento.externo_id
                              : "Não informado"
                          }}
                          <button
                            class="btn btn-outline-secondary btn-crud"
                            data-toggle="modal"
                            data-target="#externoModal"
                          >
                            <i class="fas fa-plus"></i>
                          </button>
                        </div>
                        <div
                          class="modal fade"
                          id="externoModal"
                          tabindex="-1"
                          role="dialog"
                          aria-labelledby="externoModalLabel"
                          aria-hidden="true"
                        >
                          <div class="modal-dialog" role="document">
                            <div class="modal-content">
                              <div class="modal-header">
                                <h5 class="modal-title" id="externoModalLabel">
                                  Número do episódio
                                </h5>
                                <button
                                  type="button"
                                  class="close"
                                  data-dismiss="modal"
                                  aria-label="Close"
                                >
                                  <span aria-hidden="true">&times;</span>
                                </button>
                              </div>
                              <div class="modal-body">
                                <label>Episódio</label>
                                <input
                                  type="text"
                                  class="form-control"
                                  v-model="senha.min_atendimento.externo_id"
                                />
                              </div>
                              <div class="modal-footer">
                                <button
                                  type="button"
                                  class="btn btn-outline-secondary"
                                  data-dismiss="modal"
                                >
                                  Cancelar
                                </button>
                                <button
                                  type="button"
                                  class="btn btn-secondary"
                                  data-dismiss="modal"
                                  @click="addExternoId()"
                                >
                                  Salvar
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      </td>
                    </tr>
                    <tr v-if="senha.edicao_nome_pendente">
                      <th style="white-space: nowrap">
                        <i class="fas fa-user-edit mr-75 text-warning"></i>
                        <span class="font-weight-bold text-warning"
                          >Nome pendente</span
                        >
                      </th>
                      <td>
                        <div
                          class="d-flex align-items-center flex-wrap"
                          style="gap: 6px"
                        >
                          <span
                            class="badge badge-warning"
                            style="
                              font-size: 0.85em;
                              max-width: 220px;
                              overflow: hidden;
                              text-overflow: ellipsis;
                              white-space: nowrap;
                              display: inline-block;
                              vertical-align: middle;
                            "
                            :title="senha.edicao_nome_pendente"
                          >
                            ✏️ {{ senha.edicao_nome_pendente }}
                          </span>
                          <button
                            class="btn btn-sm btn-success"
                            @click="aprovarNomePendente()"
                          >
                            <i class="fas fa-check mr-1"></i> Aprovar
                          </button>
                          <button
                            class="btn btn-sm btn-danger"
                            @click="rejeitarNomePendente()"
                          >
                            <i class="fas fa-times mr-1"></i> Rejeitar
                          </button>
                        </div>
                      </td>
                    </tr>
                    <tr v-if="senha.nome_social_pendente">
                      <th style="white-space: nowrap">
                        <i class="fas fa-user-edit mr-75 text-warning"></i>
                        <span class="font-weight-bold text-warning"
                          >Nome social pendente</span
                        >
                      </th>
                      <td>
                        <div
                          class="d-flex align-items-center flex-wrap"
                          style="gap: 6px"
                        >
                          <span
                            class="badge badge-warning"
                            style="
                              font-size: 0.85em;
                              max-width: 220px;
                              overflow: hidden;
                              text-overflow: ellipsis;
                              white-space: nowrap;
                              display: inline-block;
                              vertical-align: middle;
                            "
                            :title="senha.nome_social_pendente"
                          >
                            ✏️ {{ senha.nome_social_pendente }}
                          </span>
                          <button
                            class="btn btn-sm btn-success"
                            @click="aprovarNomeSocialPendente()"
                          >
                            <i class="fas fa-check mr-1"></i> Aprovar
                          </button>
                          <button
                            class="btn btn-sm btn-danger"
                            @click="rejeitarNomeSocialPendente()"
                          >
                            <i class="fas fa-times mr-1"></i> Rejeitar
                          </button>
                        </div>
                      </td>
                    </tr>
                  </table>
                </div>
              </div>
            </div>
            <div class="card-footer">
              <div class="row">
                <div class="col-md-3 mt-1 mt-md-0">
                  <div class="d-flex align-items-top clocks">
                    <span class="b-avatar badge-light-secondary rounded">
                      <i
                        class="far fa-clock rotating"
                        style="font-size: 18px"
                      ></i>
                    </span>
                    <div class="ml-1">
                      <h5 class="mb-0">
                        {{ tempoUnidade }}
                      </h5>
                      <small>Espera na unidade</small>
                    </div>
                  </div>
                </div>
                <div class="col-md-3 mt-1 mt-md-0">
                  <div class="d-flex align-items-top clocks">
                    <span class="b-avatar badge-light-secondary rounded">
                      <i
                        class="far fa-clock rotating"
                        style="font-size: 18px"
                      ></i>
                    </span>
                    <div class="ml-1">
                      <h5 class="mb-0">
                        {{ tempoSetor }}
                      </h5>
                      <small>Espera neste setor</small>
                    </div>
                  </div>
                </div>
                <div class="col-md-3 mt-1 mt-md-0">
                  <div class="d-flex align-items-center">
                    <div class="d-flex align-items-top clocks">
                      <span class="b-avatar badge-light-secondary rounded">
                        <i
                          class="far fa-clock rotating"
                          style="font-size: 18px"
                        ></i>
                      </span>
                      <div class="ml-1">
                        <h5 class="mb-0">
                          {{ tempoChamada }}
                        </h5>
                        <small>Última chamada</small>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-3 mt-1 mt-md-0">
                  <div class="d-flex align-items-top clocks">
                    <span class="b-avatar badge-light-secondary rounded">
                      <i
                        class="far fa-clock rotating"
                        style="font-size: 18px"
                      ></i>
                    </span>
                    <div class="ml-1">
                      <h5 class="mb-0">
                        {{ tempoInicio }}
                      </h5>
                      <small>Inicio do atendimento</small>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-3">
          <div class="card h-100 border-secondary">
            <div class="card-body">
              <h2 class="mb-0">
                {{ senha.min_atendimento.prefixo
                }}{{ senha.min_atendimento.senha }}
                <button
                  class="btn btn-crud btn-outline-secondary"
                  data-toggle="modal"
                  data-target="#senhaPath"
                  title="Histórico da senha"
                  @click="getPath()"
                >
                  <i class="fas fa-book"></i>
                </button>
                <button
                  class="btn btn-crud btn-outline-secondary"
                  data-toggle="modal"
                  data-target="#subsenha"
                  title="Adicionar Subsenhas"
                  @click="getSenhas()"
                  v-show="configuracao.sub_senha == 1"
                >
                  <i class="fas fa-plus"></i>
                </button>
              </h2>
              <small class="d-block w-100"><strong>Senha</strong></small>
              <h4 class="mt-1 mt-sm-0">
                <span>
                  <div
                    class="modal fade"
                    id="subsenha"
                    tabindex="-1"
                    role="dialog"
                    aria-labelledby="subsenhaTitle"
                    aria-hidden="true"
                    style="overflow: hidden"
                  >
                    <div class="modal-dialog modal-lg" role="document">
                      <div class="modal-content">
                        <div class="modal-header">
                          <h5 class="modal-title" id="subsenhaTitle">
                            Subsenhas
                          </h5>
                          <button
                            type="button"
                            class="close"
                            data-dismiss="modal"
                            aria-label="Close"
                          >
                            <span aria-hidden="true">&times;</span>
                          </button>
                        </div>
                        <div class="modal-body" style="font-size: 11.5pt">
                          As seguintes senhas são subsenhas dessa senha:<br />
                          <table class="table table-bordered">
                            <tr>
                              <th width="30%">Senha</th>
                              <th width="50%">Nome</th>
                              <th width="20%">Ações</th>
                            </tr>
                            <tr
                              v-for="atendimento in atendimentos"
                              :key="atendimento.id"
                            >
                              <td>
                                <b
                                  >{{ atendimento.prefixo
                                  }}{{ atendimento.senha }}</b
                                >
                              </td>
                              <td>
                                <b>{{
                                  atendimento.pessoa
                                    ? atendimento.pessoa.nome
                                    : "Não informado"
                                }}</b>
                              </td>
                              <td>
                                <button
                                  class="btn btn-delete btn-crud"
                                  @click="removeSubsenha(atendimento.id)"
                                >
                                  <i class="fas fa-trash"></i>
                                </button>
                              </td>
                            </tr>
                          </table>
                          <br />
                          Adicionar senhas existentes como subsenhas:
                          <v-select
                            :options="formattedAtendimentos"
                            :reduce="(allAtendimentos) => allAtendimentos.id"
                            :label="'label'"
                            v-model="subsenha"
                            class="vselect"
                          ></v-select>
                          <br />
                          Ou gere uma nova senha: <br /><br />
                          <button
                            class="btn btn-sm btn-outline-primary"
                            @click="abreSubSenha"
                          >
                            Abrir nova senha
                          </button>
                        </div>
                        <div class="modal-footer">
                          <button
                            type="button"
                            class="btn btn-outline-secondary"
                            data-dismiss="modal"
                          >
                            Cancelar
                          </button>
                          <button
                            type="button"
                            class="btn btn-secondary"
                            @click="addSubsenha()"
                          >
                            Salvar
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </span>
              </h4>
              <div class="info-datetime-card">
                <div class="info-datetime-item">
                  <i class="fas fa-door-open text-info mr-2"></i>
                  <div>
                    <small class="d-block mb-1">Entrada na unidade</small>
                    <h6 class="mb-0 font-weight-bold">
                      {{ senha.min_atendimento.data_inicio_f }}
                    </h6>
                  </div>
                </div>
                <div class="info-datetime-divider"></div>
                <div class="info-datetime-item">
                  <i class="fas fa-sign-in-alt text-primary mr-2"></i>
                  <div>
                    <small class="d-block mb-1">Entrada no setor</small>
                    <h6 class="mb-0 font-weight-bold">
                      {{ senha.data_entrada_f }}
                    </h6>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-12 mt-2">
          <div class="card">
            <div class="card-body">
              <div class="row d-flex justify-content-around">
                <div
                  class="col-md-3 d-flex justify-content-center my-1 p-0 flex-column"
                  v-if="!senha.data_inicio"
                  :class="senha.data_inicio ? '' : 'fadeOut'"
                >
                  <button
                    class="btn btn-outline-secondary text-dark col-11 clocks"
                    data-dismiss="modal"
                    aria-label="Close"
                    data-toggle="modal"
                    data-target="#exampleModalCenter"
                  >
                    <i class="fas fa-play mr-1"></i>Iniciar Atendimento
                  </button>
                  <div class="col-12" style="max-height: 15px; font-size: 10pt">
                    &nbsp;
                  </div>
                  <div
                    class="modal fade"
                    id="exampleModalCenter"
                    role="dialog"
                    aria-labelledby="exampleModalCenterTitle"
                    aria-hidden="true"
                  >
                    <div
                      class="modal-dialog modal-dialog-centered"
                      role="document"
                    >
                      <div class="modal-content">
                        <div class="modal-header">
                          <h5 class="modal-title" id="exampleModalLongTitle">
                            Deseja iniciar o atendimento?
                          </h5>
                          <button
                            type="button"
                            class="close"
                            data-dismiss="modal"
                            aria-label="Close"
                          >
                            <span aria-hidden="true">&times;</span>
                          </button>
                        </div>
                        <div class="modal-body w-100">
                          <div class="row">
                            <div class="col-6">
                              <button
                                type="button"
                                class="btn btn-outline-secondary w-100"
                                data-dismiss="modal"
                              >
                                Cancelar
                              </button>
                            </div>
                            <div class="col-6">
                              <button
                                type="button"
                                class="btn btn-secondary w-100"
                                data-dismiss="modal"
                                @click="iniciar()"
                              >
                                Iniciar
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  class="col-md-3 d-flex justify-content-center my-1 p-0 flex-column"
                  v-if="!senha.data_inicio"
                  :class="senha.data_inicio ? '' : 'fadeOut'"
                >
                  <button
                    class="btn btn-outline-secondary text-dark col-11 clocks"
                    :disabled="cooldown"
                    @click="chamarNovamente()"
                  >
                    <i
                      id="iconChamada"
                      class="fas fa-sync-alt"
                      v-show="!contagemRegressiva"
                    ></i
                    ><span class="" v-show="contagemRegressiva && cooldown">
                      {{ contagemRegressiva }} </span
                    ><span
                      class="ml-1"
                      v-show="!contagemRegressiva && !cooldown"
                    >
                      Chamar novamente
                    </span>
                  </button>
                  <div
                    class="col-12 text-center"
                    style="max-height: 15px; font-size: 10pt"
                  >
                    Você chamou essa senha
                    {{
                      senha.vezes_chamado === 1
                        ? senha.vezes_chamado + " vez"
                        : senha.vezes_chamado + " vezes"
                    }}
                  </div>
                </div>
                <div
                  :class="
                    (atual.finaliza ? 'col-md-2' : 'col-md-3') +
                    ' d-flex justify-content-center my-1 p-0'
                  "
                  v-if="senha.data_inicio && atual.agenda_consulta"
                >
                  <button
                    class="btn btn-outline-secondary col-11 clocks p-0"
                    data-toggle="modal"
                    data-target="#agenda"
                  >
                    <i class="fas fa-calendar mr-1"></i>Agendar Consulta
                  </button>
                  <div
                    class="modal fade"
                    id="agenda"
                    tabindex="-1"
                    role="dialog"
                    aria-labelledby="title"
                    aria-hidden="true"
                  >
                    <div class="modal-dialog" role="document">
                      <div class="modal-content">
                        <div class="modal-header">
                          <h5 class="modal-title" id="title">
                            Agendar Consulta
                          </h5>
                          <button
                            type="button"
                            class="close"
                            data-dismiss="modal"
                            aria-label="Close"
                          >
                            <span aria-hidden="true">&times;</span>
                          </button>
                        </div>
                        <div class="modal-body text-center p-1">
                          <div class="row">
                            <div class="col-md-6">
                              <label>CPF</label>
                              <div class="input-group">
                                <input
                                  type="text"
                                  class="form-control"
                                  v-model="pessoa.cpf"
                                  v-mask="'999.999.999-99'"
                                />
                                <div class="input-group-append">
                                  <button
                                    class="btn btn-secondary"
                                    type="button"
                                    @click="getCpf()"
                                  >
                                    <i class="fas fa-search"></i>
                                  </button>
                                </div>
                              </div>
                            </div>
                            <div class="col-md-6">
                              <label>CNS</label>
                              <input
                                type="text"
                                class="form-control"
                                v-model="agendamento.cns"
                                v-mask="'99999999999 9999'"
                              />
                            </div>
                            <div class="col-md-6">
                              <label>Setor</label>
                              <select
                                v-model="agendamento.setor_id"
                                class="text-center form-control"
                              >
                                <option
                                  v-for="setor in allSetores"
                                  :key="setor.id"
                                  :value="setor.id"
                                >
                                  {{
                                    setor.nome ? setor.nome : "Não informado"
                                  }}
                                </option>
                              </select>
                            </div>
                            <div class="col-md-6">
                              <label>Data</label>
                              <input
                                type="datetime-local"
                                class="form-control"
                                v-model="agendamento.data_agendado"
                              />
                            </div>
                            <div class="col-md-12">
                              <label>Nome</label>
                              <input
                                type="text"
                                class="form-control"
                                v-model="agendamento.nome"
                              />
                            </div>
                            <div class="col-md-12">
                              <label>Descrição</label>
                              <textarea
                                type="text"
                                class="form-control"
                                v-model="agendamento.descricao"
                              ></textarea>
                            </div>
                          </div>
                        </div>
                        <div class="modal-footer">
                          <button
                            type="button"
                            class="btn btn-outline-secondary"
                            data-dismiss="modal"
                          >
                            Cancelar
                          </button>
                          <button
                            type="button"
                            class="btn btn-secondary"
                            data-dismiss="modal"
                            @click="agendarConsulta()"
                          >
                            Confirmar
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  :class="
                    (atual.finaliza ? 'col-md-2' : 'col-md-3') +
                    ' d-flex justify-content-center my-1 p-0'
                  "
                  v-if="senha.data_inicio"
                >
                  <button
                    class="btn btn-outline-secondary col-11 clocks"
                    data-toggle="modal"
                    data-target="#obs"
                  >
                    <i class="fas fa-plus mr-1"></i>Adicionar nota
                  </button>
                  <div
                    class="modal fade"
                    id="obs"
                    tabindex="-1"
                    role="dialog"
                    aria-labelledby="title"
                    aria-hidden="true"
                  >
                    <div class="modal-dialog" role="document">
                      <div class="modal-content">
                        <div class="modal-header">
                          <h5 class="modal-title" id="title">Adicionar nota</h5>
                          <button
                            type="button"
                            class="close"
                            data-dismiss="modal"
                            aria-label="Close"
                          >
                            <span aria-hidden="true">&times;</span>
                          </button>
                        </div>
                        <div class="modal-body text-center p-1">
                          <div class="row">
                            <div class="col-12">
                              <label>Título</label>
                              <input
                                type="text"
                                class="form-control"
                                v-model="text.titulo"
                              />
                            </div>
                            <div class="col-12">
                              <label>Descrição</label>
                              <textarea
                                class="form-control"
                                rows="5"
                                v-model="text.descricao"
                                placeholder="Digite sua nota aqui..."
                              ></textarea>
                            </div>
                          </div>
                        </div>
                        <div class="modal-footer">
                          <button
                            type="button"
                            class="btn btn-outline-secondary"
                            data-dismiss="modal"
                          >
                            Cancelar
                          </button>
                          <button
                            type="button"
                            class="btn btn-secondary"
                            data-dismiss="modal"
                            @click="saveObservacao()"
                          >
                            Confirmar
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  :class="'col-md-3 d-flex justify-content-center my-1 p-0 flex-column'"
                  v-if="!senha.data_inicio"
                >
                  <button
                    class="btn btn-outline-secondary text-dark col-11 clocks"
                    data-toggle="modal"
                    data-target="#evasao"
                  >
                    <span class="w-100"></span
                    ><i class="fas fa-ban mr-1"></i>Não respondeu chamada
                  </button>
                  <div class="col-12" style="max-height: 15px; font-size: 10pt">
                    &nbsp;
                  </div>
                  <div
                    class="modal fade"
                    id="evasao"
                    tabindex="-1"
                    role="dialog"
                    aria-labelledby="title"
                    aria-hidden="true"
                  >
                    <div
                      class="modal-dialog modal-dialog-centered"
                      role="document"
                    >
                      <div class="modal-content">
                        <div class="modal-header">
                          <h5 class="modal-title" id="title">
                            Não respondeu a chamada
                          </h5>
                          <button
                            type="button"
                            class="close"
                            data-dismiss="modal"
                            aria-label="Close"
                          >
                            <span aria-hidden="true">&times;</span>
                          </button>
                        </div>
                        <div class="modal-body text-center p-1">
                          <button
                            class="col-md-12 btn btn-outline-secondary mt-1"
                            @click.once="ausente(0)"
                            data-dismiss="modal"
                            aria-label="Close"
                          >
                            Ausente
                          </button>
                          <button
                            class="col-md-12 btn btn-outline-secondary mt-1"
                            @click.once="ausente(1)"
                            data-dismiss="modal"
                            aria-label="Close"
                          >
                            Evasão
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  :class="
                    (atual.finaliza ? 'col-md-2' : 'col-md-3') +
                    ' d-flex justify-content-center my-1 p-0'
                  "
                  v-if="senha.data_inicio"
                >
                  <button
                    class="btn btn-outline-secondary col-11 clocks"
                    @click="abrirEncaminharModal"
                  >
                    <i class="fas fa-share mr-1"></i>Encaminhar
                  </button>
                  <div
                    class="modal fade"
                    id="encaminhar"
                    tabindex="-1"
                    role="dialog"
                    aria-labelledby="title"
                    aria-hidden="true"
                  >
                    <div
                      class="modal-dialog modal-lg modal-dialog-centered"
                      role="document"
                    >
                      <div class="modal-content">
                        <div class="modal-header">
                          <h5 class="modal-title" id="title">Encaminhar</h5>
                          <button
                            type="button"
                            class="close"
                            data-dismiss="modal"
                            aria-label="Close"
                          >
                            <span aria-hidden="true">&times;</span>
                          </button>
                        </div>
                        <div class="modal-body text-center p-1">
                          <div class="row">
                            <div
                              :class="
                                'mt-1 col-md-' +
                                (setores.length > 23
                                  ? '3'
                                  : setores.length > 11
                                  ? '4'
                                  : setores.length > 5
                                  ? '6'
                                  : '12')
                              "
                              v-for="setor in setores"
                              :key="setor.id"
                            >
                              <button
                                class="btn btn-outline-secondary w-100"
                                @click.once="encaminhar(setor.setor.id)"
                                data-dismiss="modal"
                                aria-label="Close"
                              >
                                {{
                                  setor.setor
                                    ? setor.setor.nome
                                    : "Não informado"
                                }}
                              </button>
                            </div>
                            <div class="col-12">
                              <hr />
                            </div>
                            <div
                              :class="
                                'col-md-' + (setores.length > 5 ? '6' : '12')
                              "
                            >
                              <button
                                class="btn btn-outline-secondary w-100"
                                @click.once="espera()"
                                data-dismiss="modal"
                                aria-label="Close"
                                v-if="atual.espera"
                              >
                                Espera
                              </button>
                            </div>
                            <div
                              :class="
                                'mt-1 col-md-' +
                                (setores.length > 5 ? '6' : '12')
                              "
                            >
                              <button
                                class="btn btn-outline-secondary w-100"
                                @click.once="medicacao()"
                                data-dismiss="modal"
                                aria-label="Close"
                                v-if="atual.medicacao"
                              >
                                Reavaliação
                              </button>
                            </div>
                            <div
                              class="mt-1 col-12 d-flex justify-content-center align-items-center flex-column"
                            >
                              <label>Tempo para reavaliação (minutos)</label>
                              <input
                                type="number"
                                class="form-control text-center w-50"
                                v-model="reavaliacao"
                                :disabled="reavaliacaoPersonalizada"
                              />
                            </div>
                            <div
                              class="mt-1 col-12 d-flex justify-content-center align-items-center flex-row"
                            >
                              <button
                                type="button"
                                class="btn btn-outline-secondary"
                                @click="
                                  reavaliacao = 10;
                                  reavaliacaoPersonalizada = true;
                                "
                              >
                                10m
                              </button>
                              <button
                                type="button"
                                class="btn btn-outline-secondary ml-1"
                                @click="
                                  reavaliacao = 20;
                                  reavaliacaoPersonalizada = true;
                                "
                              >
                                20m
                              </button>
                              <button
                                type="button"
                                class="btn btn-outline-secondary ml-1"
                                @click="
                                  reavaliacao = 30;
                                  reavaliacaoPersonalizada = true;
                                "
                              >
                                30m
                              </button>
                              <button
                                type="button"
                                class="btn btn-outline-secondary ml-1"
                                @click="
                                  reavaliacao = 50;
                                  reavaliacaoPersonalizada = true;
                                "
                              >
                                50m
                              </button>
                              <button
                                type="button"
                                class="btn btn-outline-secondary ml-1"
                                @click="
                                  reavaliacao = 70;
                                  reavaliacaoPersonalizada = true;
                                "
                              >
                                1h10m
                              </button>
                              <button
                                type="button"
                                class="btn btn-outline-secondary ml-1"
                                @click="reavaliacaoPersonalizada = false"
                              >
                                Personalizado
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  :class="
                    atual.finaliza
                      ? 'col-md-2 d-flex justify-content-center my-1 p-0'
                      : 'd-none'
                  "
                  v-if="senha.data_inicio"
                >
                  <button
                    class="btn btn-outline-secondary col-11 clocks"
                    data-toggle="modal"
                    data-target="#finaliza-senha"
                  >
                    <i class="fas fa-stopwatch mr-1"></i>Finalizar senha
                  </button>
                  <div
                    class="modal fade"
                    id="finaliza-senha"
                    tabindex="-1"
                    role="dialog"
                    aria-labelledby="title"
                    aria-hidden="true"
                  >
                    <div class="modal-dialog" role="document">
                      <div class="modal-content">
                        <div class="modal-header">
                          <h5 class="modal-title" id="title">
                            Finalizar Senha
                          </h5>
                          <button
                            type="button"
                            class="close"
                            data-dismiss="modal"
                            aria-label="Close"
                          >
                            <span aria-hidden="true">&times;</span>
                          </button>
                        </div>
                        <div class="modal-body text-center p-1">
                          <div class="row">
                            <div
                              :class="
                                'mt-1 col-md-' +
                                (finalizacao.length > 5 ? '6' : '12')
                              "
                              v-for="(motivo, index) in finalizacao"
                              :key="index"
                            >
                              <button
                                class="btn btn-outline-secondary w-100"
                                data-dismiss="modal"
                                aria-label="Close"
                                @click.once="finalizar(motivo.id)"
                              >
                                {{
                                  motivo.nome ? motivo.nome : "Não informado"
                                }}
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- Alterar Classificação de Risco -->
              <div
                class="row mt-2 px-1"
                v-if="senha.setor && senha.min_setor.classifica == 1"
              >
                <div class="col-12">
                  <label class="mb-1"
                    ><i class="fas fa-tag mr-1"></i>Alterar classificação de
                    risco</label
                  >
                  <div class="d-flex">
                    <v-select
                      :options="classificacao"
                      :reduce="(c) => c.id"
                      label="nome"
                      v-model="senha.classificacao_id"
                      placeholder="Selecione a classificação..."
                      class="vselect flex-grow-1"
                    >
                      <template #option="{ nome, cor }">
                        <span
                          :style="
                            'display:inline-block;width:12px;height:12px;border-radius:50%;background:' +
                            cor +
                            ';margin-right:6px;'
                          "
                        ></span>
                        {{ nome }}
                      </template>
                      <template #selected-option="{ nome, cor }">
                        <span
                          :style="
                            'display:inline-block;width:12px;height:12px;border-radius:50%;background:' +
                            cor +
                            ';margin-right:6px;'
                          "
                        ></span>
                        {{ nome }}
                      </template>
                    </v-select>
                    <button
                      class="btn btn-secondary ml-2"
                      @click="classifica()"
                    >
                      <i class="fas fa-check"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-12" v-if="anotacoes.length">
          <div class="card notas-container">
            <div class="card-header notas-header">
              <div class="d-flex align-items-center justify-content-between">
                <div class="d-flex align-items-center">
                  <i
                    class="fas fa-sticky-note mr-2"
                    style="font-size: 20px"
                  ></i>
                  <h5 class="mb-0 mr-1">Notas do Atendimento</h5>
                </div>
                <span class="badge badge-primary badge-pill">{{
                  anotacoes.length
                }}</span>
              </div>
            </div>
            <div class="card-body p-2">
              <div class="notas-list">
                <div
                  class="nota-item"
                  v-for="(anotacao, index) in anotacoes"
                  :key="index"
                >
                  <div class="nota-card">
                    <div class="nota-header-info">
                      <div class="d-flex align-items-center">
                        <span
                          class="b-avatar badge-light-info rounded mr-2"
                          style="width: 32px; height: 32px"
                        >
                          <span style="font-size: 12px; font-weight: bold">
                            {{
                              anotacao.user.name.substring(0, 2).toUpperCase()
                            }}
                          </span>
                        </span>
                        <div>
                          <div class="nota-author">
                            {{ anotacao.user.name }}
                          </div>
                          <div class="nota-timestamp">
                            <i class="far fa-clock mr-1"></i
                            >{{ anotacao.created_at_f }}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="nota-content">
                      <h6 class="nota-title">
                        <i class="fas fa-bookmark mr-1"></i
                        >{{ anotacao.titulo }}
                      </h6>
                      <div
                        class="nota-description"
                        v-html="anotacao.descricao"
                      ></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      class="modal fade"
      id="aresTriagemModal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="aresTriagemModalLabel"
      aria-hidden="true"
      data-backdrop="static"
      data-keyboard="false"
    >
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header bg-secondary">
            <h5 class="modal-title text-light" id="aresTriagemModalLabel">
              Integração com Ares Triagem
            </h5>
          </div>
          <div class="modal-body">
            <h5>
              Essa senha está sendo atendida no Ares Triagem, por favor, retorne
              a fila
            </h5>
          </div>
          <div class="modal-footer d-flex justify-content-center">
            <button class="btn btn-outline-secondary" @click="getFila()">
              Retornar
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { isInsideCombinedSymbol } from "ckeditor5/src/utils";
import BaseCrud from "../../layouts/Base/BaseCrud";
import vSelect from "vue-select";
import swal from "sweetalert";
// import ClassicEditor from "@ckeditor/ckeditor5-build-classic";

export default {
  name: "imageUpload",
  data() {
    return {
      fotoUrl: null,
      cooldown: false,
      contagemRegressiva: 0,
      img: ((screen.width + screen.height) / 2) * 0.1,
      text: {},
      loader: 0,
      atual: [],
      anotacoes: [],
      anotacao: 0,
      classificacao: [],
      finalizacao: [],
      agendamento: {
        setor_id: "",
        nome: "",
        cns: "",
        cpf: "",
        data_agendado: "",
      },
      pessoa: {
        nome: "",
        nome_social: "",
        nome_mae: "",
        nome_pai: "",
        cns: "",
        cpf: "",
        sexo: "",
        data_nascimento: "",
        telefone: "",
        foto: "",
      },
      allSetores: [],
      setores: [],
      senha: {
        atendimento: {
          prefixo: "-",
          senha: "----",
        },
        min_atendimento: {
          id: null,
          pessoa_id: null,
          externo_id: null,
          prefixo: "-",
          senha: "----",
          data_inicio_f: null,
          data_inicio_diff: null,
          botao_id: null,
          respostas_questionario: [],
          linhas_cuidado_questionario: [],
        },
        classificacao: {
          nome: "Sem classificação",
          cor: "#666",
        },
        edicao_nome_pendente: null,
        nome_social_pendente: null,
      },
      tempoUnidade: "--:--:--",
      tempoSetor: "--:--:--",
      tempoInicio: "--:--:--",
      tempoChamada: "--:--:--",
      atendimentos: [],
      allAtendimentos: [],
      subsenha: "",
      configuracao: [],
      prioridade: "",
      reavaliacaoPersonalizada: true,
      reavaliacao: 0,
      senhaPath: [],
      historicoAtendimentos: [], // Lista de atendimentos da pessoa
      loadingHistorico: false, // Loading para o modal
      historicoPage: 1,
      historicoHasMore: false,
      historicoCarregandoMais: false,
      contadorSetor: null,
      contadorInicio: null,
      contadorUnidade: null,
    };
  },
  computed: {
    linhasCuidadoSugeridas() {
      return (
        (this.senha.min_atendimento &&
          this.senha.min_atendimento.linhas_cuidado_questionario) ||
        []
      );
    },
    respostasDoQuestionario() {
      const respostas =
        (this.senha.min_atendimento && this.senha.min_atendimento.respostas_questionario) ||
        [];
      const agrupado = [];

      respostas.forEach((item) => {
        const existente = agrupado.find((linha) => linha.pergunta === item.pergunta);

        if (existente) {
          existente.respostas.push(item.resposta);
          return;
        }

        agrupado.push({ pergunta: item.pergunta, respostas: [item.resposta] });
      });

      return agrupado;
    },
    formattedAtendimentos() {
      return this.allAtendimentos.map((atendimento) => {
        return {
          ...atendimento,
          label: `${atendimento.prefixo}${atendimento.senha}`,
        };
      });
    },
  },
  methods: {
    aprovarNomePendente: function () {
      const self = this;
      swal({
        title: "Aprovar alteração de nome?",
        text: `O nome "${self.senha.edicao_nome_pendente}" será aplicado a esta pessoa.`,
        icon: "warning",
        buttons: {
          cancel: { text: "Cancelar", visible: true },
          confirm: { text: "Aprovar", className: "btn-success" },
        },
      }).then((confirmar) => {
        if (!confirmar) return;
        const api =
          self.$store.state.api +
          "atendimento_setor/" +
          self.senha.id +
          "/aprovar-edicao-nome";
        axios
          .post(api)
          .then(() => {
            swal({ title: "Nome aprovado!", icon: "success", button: "OK" });
            if (self.pessoa) {
              self.pessoa.nome = self.senha.edicao_nome_pendente;
            }
            self.senha.edicao_nome_pendente = null;
            self.getSenha(self.$route.params.id);
          })
          .catch((error) => {
            self.$message(
              "Erro",
              error.response?.data?.message ||
                error.response?.data ||
                "Erro ao aprovar.",
              "error"
            );
          });
      });
    },
    rejeitarNomePendente: function () {
      const self = this;
      swal({
        title: "Rejeitar alteração de nome?",
        text: `O nome "${self.senha.edicao_nome_pendente}" será descartado.`,
        icon: "warning",
        buttons: {
          cancel: { text: "Cancelar", visible: true },
          confirm: { text: "Rejeitar", className: "btn-danger" },
        },
        dangerMode: true,
      }).then((confirmar) => {
        if (!confirmar) return;
        const api =
          self.$store.state.api +
          "atendimento_setor/" +
          self.senha.id +
          "/rejeitar-edicao-nome";
        axios
          .post(api)
          .then(() => {
            swal({ title: "Nome rejeitado!", icon: "success", button: "OK" });
            self.senha.edicao_nome_pendente = null;
            self.getSenha(self.$route.params.id);
          })
          .catch((error) => {
            self.$message(
              "Erro",
              error.response?.data || "Erro ao rejeitar.",
              "error"
            );
          });
      });
    },
    aprovarNomeSocialPendente: function () {
      const self = this;
      swal({
        title: "Aprovar nome social?",
        text: `O nome social "${self.senha.nome_social_pendente}" será aplicado a esta pessoa.`,
        icon: "warning",
        buttons: {
          cancel: { text: "Cancelar", visible: true },
          confirm: { text: "Aprovar", className: "btn-success" },
        },
      }).then((confirmar) => {
        if (!confirmar) return;
        const api =
          self.$store.state.api +
          "atendimento_setor/" +
          self.senha.id +
          "/aprovar-edicao-nome-social";
        axios
          .post(api)
          .then(() => {
            swal({ title: "Nome social aprovado!", icon: "success", button: "OK" });
            if (self.pessoa) {
              self.pessoa.nome_social = self.senha.nome_social_pendente;
            }
            self.senha.nome_social_pendente = null;
            self.getSenha(self.$route.params.id);
          })
          .catch((error) => {
            self.$message(
              "Erro",
              error.response?.data?.message ||
                error.response?.data ||
                "Erro ao aprovar.",
              "error"
            );
          });
      });
    },
    rejeitarNomeSocialPendente: function () {
      const self = this;
      swal({
        title: "Rejeitar nome social?",
        text: `O nome social "${self.senha.nome_social_pendente}" será descartado.`,
        icon: "warning",
        buttons: {
          cancel: { text: "Cancelar", visible: true },
          confirm: { text: "Rejeitar", className: "btn-danger" },
        },
        dangerMode: true,
      }).then((confirmar) => {
        if (!confirmar) return;
        const api =
          self.$store.state.api +
          "atendimento_setor/" +
          self.senha.id +
          "/rejeitar-edicao-nome-social";
        axios
          .post(api)
          .then(() => {
            swal({ title: "Nome social rejeitado!", icon: "success", button: "OK" });
            self.senha.nome_social_pendente = null;
            self.getSenha(self.$route.params.id);
          })
          .catch((error) => {
            self.$message(
              "Erro",
              error.response?.data || "Erro ao rejeitar.",
              "error"
            );
          });
      });
    },
    getSenha: function (id) {
      const self = this;
      const api =
        self.$store.state.api +
        "atendimento_setor/" +
        id +
        "?with[]=min_atendimento&with[]=min_atendimento.respostasQuestionario&with[]=min_atendimento.linhasCuidadoQuestionario&with[]=classificacao&with[]=min_setor&whereNull=data_fim";

      axios
        .get(api)
        .then((response) => {
          if (response.data.data.length === 0) {
            self.$message(
              null,
              "Senha não encontrada ou já finalizada.",
              "error"
            );
            this.$router.push("/chamador");
            return;
          }
          self.senha = response.data.data[0];

          if (!self.senha.classificacao) {
            self.senha.classificacao = {
              nome: "Sem classificação",
              cor: "#666",
            };
          }

          if (!self.senha.data_inicio) {
            self.timerUnidade(self.senha.min_atendimento.data_inicio_diff);
            self.timerSetor(self.senha.data_entrada_diff);
            self.timerChamada(self.senha.data_ultima_chamada_diff);
          } else {
            if (
              self.atual.envia_ares_triagem &&
              self.configuracao.integra_ares_triagem
            ) {
              $("#aresTriagemModal").modal("toggle");
            }

            self.timerUnidade(self.senha.min_atendimento.data_inicio_diff);
            self.timerSetor(self.senha.data_entrada_diff);
            self.timerInicio(self.senha.data_inicio_diff);
            self.timerChamada(self.senha.data_ultima_chamada_diff);
          }

          self.prioridade = self.senha.prioridade;

          self.getSetorAtual();
          self.getAnotacoes();

          if (self.senha.min_atendimento.pessoa_id) {
            self.getPessoa(self.senha.min_atendimento.pessoa_id);
          }
          self.$loading(false);
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    getAnotacoes: function () {
      const self = this;
      const api =
        self.$store.state.api +
        `anotacoes?paginated=false&orderByDesc=created_at&with[]=user&atendimento_id=${self.senha.min_atendimento.id}`;

      axios
        .get(api)
        .then((response) => {
          self.anotacoes = response.data.data;
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    chamarNovamente: function () {
      const self = this;
      const api =
        self.$store.state.api + "chamar_novamente/" + self.$route.params.id;

      self.cooldown = true;
      self.senha.vezes_chamado++;

      clearInterval(self.contadorChamada);

      $({ deg: 0 }).animate(
        { deg: 720 },
        {
          step: function (now, fx) {
            $("#iconChamada").css({
              transform: "rotate(" + now + "deg)",
            });
          },
        }
      );

      setTimeout(() => {
        self.contagemRegressiva = self.configuracao.cooldown;

        let contagem = setInterval(() => {
          self.contagemRegressiva--;
        }, 1000);

        setTimeout(() => {
          self.cooldown = false;
          clearInterval(contagem);
        }, self.contagemRegressiva * 1000);
      }, 1000);

      self.timerChamada(0);

      axios
        .post(api)
        .then(() => {
          self.$message(null, "Senha chamada", "info");
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    classificar: function () {
      $("#classificacaoModal").modal("toggle");
    },
    pessoaModal: function () {
      $("#pessoaModal").modal("toggle");
    },
    getHistoricoPessoa: function () {
      const self = this;

      if (!self.pessoa || !self.pessoa.id) {
        self.$message("Atenção", "Pessoa não identificada", "warning");
        return;
      }

      self.loadingHistorico = true;
      self.historicoAtendimentos = [];
      self.historicoPage = 1;
      self.historicoHasMore = false;

      const api =
        self.$store.state.api +
        "historico-pessoa/" +
        self.pessoa.id +
        "?page=1";

      axios
        .get(api)
        .then((response) => {
          self.historicoAtendimentos = response.data.data || [];
          self.historicoHasMore = response.data.has_more;
          self.loadingHistorico = false;

          // Registra listener de scroll no modal após renderizar
          self.$nextTick(() => {
            const modalBody = document.querySelector(
              "#historicoAtendimentosModal .timeline-body"
            );
            if (modalBody) {
              modalBody.onscroll = null;
              modalBody.onscroll = function () {
                const nearBottom =
                  modalBody.scrollTop + modalBody.clientHeight >=
                  modalBody.scrollHeight - 100;
                if (
                  nearBottom &&
                  self.historicoHasMore &&
                  !self.historicoCarregandoMais
                ) {
                  self.carregarMaisHistorico();
                }
              };
            }
          });
        })
        .catch((error) => {
          self.loadingHistorico = false;
          self.$message(
            "Erro",
            "Não foi possível carregar o histórico de atendimentos",
            "error"
          );
        });
    },
    carregarMaisHistorico: function () {
      const self = this;

      if (!self.historicoHasMore || self.historicoCarregandoMais) return;

      self.historicoCarregandoMais = true;
      self.historicoPage++;

      const api =
        self.$store.state.api +
        "historico-pessoa/" +
        self.pessoa.id +
        "?page=" +
        self.historicoPage;

      axios
        .get(api)
        .then((response) => {
          self.historicoAtendimentos = self.historicoAtendimentos.concat(
            response.data.data || []
          );
          self.historicoHasMore = response.data.has_more;
          self.historicoCarregandoMais = false;
        })
        .catch(() => {
          self.historicoCarregandoMais = false;
        });
    },
    getClassificacao: function () {
      const self = this;
      const cached = self.$store.state.classificacoes_cache;
      const cachedData =
        cached && Array.isArray(cached.data)
          ? cached.data
          : Array.isArray(cached)
          ? cached
          : [];

      if (cachedData.length) {
        self.classificacao = cachedData;
        self.setLoader(25);
        return;
      }

      axios
        .get(self.$store.state.api + "classificacoes?paginated=false&ativo=1")
        .then((response) => {
          self.classificacao = response.data.data;
          self.$store.commit("setClassificacoesCache", {
            data: response.data.data,
            updatedAt: Date.now(),
          });
          self.setLoader(25);
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    classifica: function () {
      const self = this;
      const api = self.$store.state.api + "classifica/" + self.$route.params.id;

      axios
        .post(api, { classificacao_id: self.senha.classificacao_id })
        .then(() => {
          self.$message(
            "Sucesso",
            `Informações guardadas com sucesso`,
            "success"
          );
          self.getSenha(self.$route.params.id);
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    getPessoa: function (id) {
      const self = this;
      const api = self.$store.state.api + "pessoas/" + id;

      axios
        .get(api)
        .then((response) => {
          self.pessoa = response.data.data[0];
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    makeFormData: function () {
      const self = this;
      let foto = document.getElementById("userPic");
      let fd = new FormData();

      // Limpar máscara do CPF (remover pontos e traço) antes de enviar
      const cpfLimpo = self.pessoa.cpf
        ? self.pessoa.cpf.replace(/[\.\-\/\s]/g, "")
        : "";

      fd.append("cpf", cpfLimpo);
      fd.append("cns", self.pessoa.cns ? self.pessoa.cns : "");
      fd.append("nome", self.pessoa.nome ? self.pessoa.nome : "");
      fd.append(
        "nome_social",
        self.pessoa.nome_social ? self.pessoa.nome_social : ""
      );
      fd.append("nome_mae", self.pessoa.nome_mae ? self.pessoa.nome_mae : "");
      fd.append("nome_pai", self.pessoa.nome_pai ? self.pessoa.nome_pai : "");
      fd.append("cep", self.pessoa.cep ? self.pessoa.cep : "");
      fd.append(
        "logradouro",
        self.pessoa.logradouro ? self.pessoa.logradouro : ""
      );
      fd.append("numero", self.pessoa.numero ? self.pessoa.numero : "");
      fd.append(
        "complemento",
        self.pessoa.complemento ? self.pessoa.complemento : ""
      );
      fd.append("bairro", self.pessoa.bairro ? self.pessoa.bairro : "");
      fd.append("cidade", self.pessoa.cidade ? self.pessoa.cidade : "");
      fd.append("estado", self.pessoa.estado ? self.pessoa.estado : "");
      fd.append("telefone", self.pessoa.telefone ? self.pessoa.telefone : "");
      fd.append(
        "data_nascimento",
        self.pessoa.data_nascimento_form ? self.pessoa.data_nascimento_form : ""
      );
      fd.append("sexo", self.pessoa.sexo ? self.pessoa.sexo : "");

      // Se tem foto capturada da webcam (base64), envia ela
      if (self.pessoa.foto && self.pessoa.foto.startsWith("data:image")) {
        fd.append("foto", self.pessoa.foto);
      } else if (foto && foto.files[0]) {
        // Senão, envia o arquivo do input file
        fd.append("foto", foto.files[0]);
      } else {
        fd.append("foto", "");
      }

      if (self.pessoa.id) {
        fd.append("id", self.pessoa.id);
        fd.append("_method", "PUT");
      }

      return fd;
    },
    parseErro: function (error) {
      // A API já devolve mensagem limpa (string) ou mapa de validação
      // { campo: ["msg", ...] }. Aqui só convertemos para texto exibível.
      const data = error && error.response ? error.response.data : null;
      if (!data) return "Não foi possível concluir a operação";
      if (typeof data === "string") return data;
      if (typeof data === "object") {
        const msgs = Object.values(data)
          .flat()
          .filter((m) => typeof m === "string");
        if (msgs.length) return msgs.join("\n");
      }
      return "Não foi possível concluir a operação";
    },
    savePessoa: function () {
      const self = this;

      if (!self.pessoa.nome || !self.pessoa.nome.trim()) {
        self.$message(null, "O campo Nome é obrigatório", "warning");
        return;
      }
      // if (!self.pessoa.telefone || !self.pessoa.telefone.trim()) {
      //   self.$message(null, "O campo Telefone é obrigatório", "warning");
      //   return;
      // }

      var api = self.$store.state.api + "pessoas/";

      self.$loading(true);

      if (self.pessoa.id) {
        api += self.pessoa.id;
      }

      let fd = self.makeFormData();

      axios
        .post(api, fd)
        .then((response) => {
          self.$message(
            "Sucesso",
            `Informações guardadas com sucesso`,
            "success"
          );

          if (response.data && response.data.id) {
            self.addPessoa(response.data.id);
            self.getPessoa(response.data.id);
          }
          self.$loading(false);
        })
        .catch((error) => {
          self.$loading(false);
          self.$message(null, self.parseErro(error), "error");
        });
    },
    saveObservacao: function () {
      const self = this;
      const api = self.$store.state.api + "anotacoes";

      self.$loading(true);

      axios
        .post(api, {
          usuario_id: self.$store.state.user.id,
          atendimento_id: self.senha.min_atendimento.id,
          titulo: self.text.titulo,
          descricao: self.text.descricao,
        })
        .then(() => {
          self.$loading(false);
          self.getAnotacoes();
          self.text = {};
        })
        .catch((error) => {
          self.$loading(false);
          self.$message(null, error.response.data, "error");
        });
    },
    addPessoa: function (id) {
      const self = this;
      const api =
        self.$store.state.api + "addPessoa/" + self.senha.min_atendimento.id;

      axios
        .post(api, { pessoa_id: id })
        .then(() => {})
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    getSetorAtual: function () {
      const self = this;
      const setorId = self.$store.state.user.setor;

      if (!setorId) return;
      const cached = self.$store.state.all_setores_cache;

      if (cached && cached.length) {
        const found = cached.find((s) => s.id === setorId);
        if (found) {
          self.atual = found;
          self.getSetores();
          return;
        }
      }

      axios
        .get(self.$store.state.api + "setores?ativo=1&id=" + setorId)
        .then((response) => {
          self.atual =
            response.data.data.length > 0 ? response.data.data[0] : [];
          self.getSetores();
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    getSetores: function (forceRefresh = false) {
      const self = this;
      const setorId = self.$store.state.user.setor;
      const cached = self.$store.state.fluxo_setores_cache[setorId];

      const cachedFluxo =
        cached && Array.isArray(cached.data)
          ? cached.data
          : Array.isArray(cached)
          ? cached
          : [];

      if (cachedFluxo.length && !forceRefresh) {
        self.setores = cachedFluxo;
        self.getAllSetores();
        self.setLoader(12);
        return Promise.resolve(cachedFluxo);
      }

      const api =
        self.$store.state.api +
        "fluxo_setores?paginated=false&with[]=setor&ativo=1&setor_original_id=" +
        setorId;

      return axios
        .get(api)
        .then((response) => {
          const ativos = response.data.data.filter(
            (fluxoSetor) => fluxoSetor.setor && fluxoSetor.setor.ativo
          );

          self.setores = ativos;
          self.$store.commit("setFluxoSetoresCache", {
            setorId,
            fluxo: {
              data: ativos,
              updatedAt: Date.now(),
            },
          });
          self.getAllSetores();
          self.setLoader(12);

          return ativos;
        })
        .catch((error) => {
          console.error("Erro ao buscar fluxo de setores:", error);

          if (cachedFluxo.length) {
            return cachedFluxo;
          }

          self.$message(null, error.response.data, "error");
          return Promise.reject(error);
        });
    },
    abrirEncaminharModal: function () {
      const self = this;

      self.$loading(true);
      self
        .getSetores()
        .then(() => {
          $("#encaminhar").modal("show");
        })
        .catch((error) => {
          console.error("Erro ao abrir modal de encaminhamento:", error);
        })
        .finally(() => {
          self.$loading(false);
        });
    },
    getAllSetores: function () {
      const self = this;
      const cached = self.$store.state.all_setores_cache;

      if (cached && cached.length) {
        self.allSetores = cached;
        self.setLoader(13);
        return;
      }

      axios
        .get(self.$store.state.api + "setores?ativo=1&paginated=false")
        .then((response) => {
          self.allSetores = response.data.data;
          self.$store.commit("setAllSetoresCache", response.data.data);
          self.setLoader(13);
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    getFinalizacao: function () {
      const self = this;
      const cached = self.$store.state.finalizacoes_cache;
      const cachedData =
        cached && Array.isArray(cached.data)
          ? cached.data
          : Array.isArray(cached)
          ? cached
          : [];

      if (cachedData.length) {
        self.finalizacao = cachedData;
        self.setLoader(25);
        return;
      }

      axios
        .get(self.$store.state.api + "finalizacoes?paginated=false&ativo=1")
        .then((response) => {
          self.finalizacao = response.data.data;
          self.$store.commit("setFinalizacoesCache", {
            data: response.data.data,
            updatedAt: Date.now(),
          });
          self.setLoader(25);
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    getConfiguracao: function () {
      const self = this;
      const cached = self.$store.state.configuracao_cache;
      const cachedData = cached
        ? cached.updatedAt
          ? cached.data
          : cached
        : null;

      if (cachedData) {
        self.configuracao = cachedData;
        self.setLoader(25);
        return;
      }

      axios
        .get(self.$store.state.api + "configuracoes/")
        .then((response) => {
          const config = response.data.data[0];
          self.configuracao = config;
          self.$store.commit("setConfiguracaoCache", {
            data: config,
            updatedAt: Date.now(),
          });
          self.setLoader(25);
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    iniciar: function () {
      const self = this;
      const api = self.$store.state.api + "iniciar/" + self.$route.params.id;

      if (
        self.atual.envia_ares_triagem &&
        self.configuracao.integra_ares_triagem
      ) {
        $("#aresTriagemModal").modal("toggle");
      }

      self.$loading(true);

      axios
        .get(api)
        .then((response) => {
          self.timerInicio(0);
          self.senha.data_inicio = response.data;
          self.$loading(false);
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
          self.$loading(false);
          self.$router.push("/chamador");
        });
    },
    ausente: function (tipo) {
      const self = this;

      self.$loading(true);

      if (tipo) {
        var rota = "evasao";
      } else {
        var rota = "ausente";
      }
      const api = self.$store.state.api + rota + "/" + self.$route.params.id;

      axios
        .post(api)
        .then(() => {
          self.$loading(false);
          self.$message(
            "Sucesso",
            `Informações guardadas com sucesso`,
            "success"
          );

          this.$router.push("/chamador");
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    encaminhar: function (id) {
      const self = this;
      const api = self.$store.state.api + "encaminhar/" + self.$route.params.id;

      self.$loading(true);

      axios
        .post(api, { setor_id: id })
        .then(() => {
          self.$message(
            "Sucesso",
            `Informações guardadas com sucesso`,
            "success"
          );
          self.$loading(false);
          this.$router.push("/chamador");
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    espera: function () {
      const self = this;
      const api = self.$store.state.api + "espera/" + self.$route.params.id;
      self.$loading(true);

      axios
        .post(api, { reavaliacao: self.reavaliacao })
        .then(() => {
          self.$message(
            "Sucesso",
            `Informações guardadas com sucesso`,
            "success"
          );

          self.$loading(false);
          this.$router.push("/chamador");
        })
        .catch((error) => {
          self.$loading(false);
          self.$message(null, error.response.data, "error");
        });
    },
    medicacao: function () {
      const self = this;
      const api = self.$store.state.api + "medicacao/" + self.$route.params.id;
      self.$loading(true);

      axios
        .post(api, { reavaliacao: self.reavaliacao })
        .then(() => {
          self.$message(
            "Sucesso",
            `Informações guardadas com sucesso`,
            "success"
          );

          self.$loading(false);
          this.$router.push("/chamador");
        })
        .catch((error) => {
          self.$loading(false);
          self.$message(null, error.response.data, "error");
        });
    },
    finalizar: function (id) {
      const self = this;
      const api = self.$store.state.api + "finalizar/" + self.$route.params.id;
      self.$loading(true);

      axios
        .post(api, { finalizacao_id: id })
        .then(() => {
          self.$message(
            "Sucesso",
            `Informações guardadas com sucesso`,
            "success"
          );

          self.$loading(false);
          this.$router.push("/chamador");
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    timerSetor: function (tempo_inicial) {
      const self = this;

      clearInterval(self.contadorSetor);
      var segundos = tempo_inicial;
      var minutos = 0;
      var horas = 0;

      self.contadorSetor = setInterval(function () {
        segundos++;

        if (segundos > 60) {
          minutos = Math.floor(segundos / 60);
        }

        if (minutos > 60) {
          horas = Math.floor(minutos / 60);
        }

        self.tempoSetor =
          horas.toString().padStart(2, "0") +
          ":" +
          (minutos % 60).toString().padStart(2, "0") +
          ":" +
          (segundos % 60).toString().padStart(2, "0");
      }, 1000);
    },
    timerInicio: function (tempo_inicial) {
      const self = this;

      clearInterval(self.contadorInicio);
      var segundos = tempo_inicial;
      var minutos = 0;
      var horas = 0;

      self.contadorInicio = setInterval(function () {
        segundos++;

        if (segundos > 60) {
          minutos = Math.floor(segundos / 60);
        }

        if (minutos > 60) {
          horas = Math.floor(minutos / 60);
        }

        self.tempoInicio =
          horas.toString().padStart(2, "0") +
          ":" +
          (minutos % 60).toString().padStart(2, "0") +
          ":" +
          (segundos % 60).toString().padStart(2, "0");
      }, 1000);
    },
    timerUnidade: function (tempo_inicial) {
      const self = this;

      clearInterval(self.contadorUnidade);
      var segundos = tempo_inicial;
      var minutos = 0;
      var horas = 0;

      self.contadorUnidade = setInterval(function () {
        segundos++;

        if (segundos > 60) {
          minutos = Math.floor(segundos / 60);
        }

        if (minutos > 60) {
          horas = Math.floor(minutos / 60);
        }

        self.tempoUnidade =
          horas.toString().padStart(2, "0") +
          ":" +
          (minutos % 60).toString().padStart(2, "0") +
          ":" +
          (segundos % 60).toString().padStart(2, "0");
      }, 1000);
    },
    timerChamada: function (tempo_inicial) {
      const self = this;

      clearInterval(self.contadorChamada);
      var segundos = tempo_inicial;
      var minutos = 0;
      var horas = 0;

      self.contadorChamada = setInterval(function () {
        segundos++;

        if (segundos > 60) {
          minutos = Math.floor(segundos / 60);
        }

        if (minutos > 60) {
          horas = Math.floor(minutos / 60);
        }

        self.tempoChamada =
          horas.toString().padStart(2, "0") +
          ":" +
          (minutos % 60).toString().padStart(2, "0") +
          ":" +
          (segundos % 60).toString().padStart(2, "0");
      }, 1000);
    },
    setLoader: function (qtd) {
      const self = this;

      let load = 0;
      let interval = setInterval(function () {
        self.loader++;
        load++;

        if (load == qtd) {
          clearInterval(interval);
        }
      }, 15);
    },
    getCpf: function () {
      const self = this;

      if (self.pessoa.cpf.split("")[13] !== "_") {
        const api = self.$store.state.api + "get-cpf";

        axios
          .post(api, {
            documento: self.pessoa.cpf.replace("-", "").replaceAll(".", ""),
            tipoDocumento: "CPF",
          })
          .then((response) => {
            if (response.data.erro) {
              return self.$message("Atenção!", "CPF não encontrado", "warning");
            }

            if (
              !response.data.pessoa ||
              !response.data.pessoa.content ||
              Object.keys(response.data.pessoa.content).length === 0
            ) {
              return self.$message("Atenção!", "CPF não encontrado", "warning");
            }

            const dados = response.data.pessoa.content;

            self.pessoa.nome = dados.nome;
            self.pessoa.nome_social = dados.nomeSocial || dados.nome;
            self.pessoa.nome_mae = dados.nomeMae;
            self.pessoa.nome_pai = dados.nomePai;
            self.pessoa.cns = dados.codigoCNS;
            self.pessoa.cpf = dados.cpf;
            self.pessoa.sexo = dados.sexo;
            self.pessoa.data_nascimento = dados.dataNascimento;
            self.pessoa.data_nascimento_form =
              dados.dataNascimento?.split("T")[0] || "";
            self.pessoa.telefone =
              dados.telefoneCelular || dados.telefoneResidencial || "";
            self.pessoa.cep = dados.cep;
            self.pessoa.logradouro = dados.logradouro;
            self.pessoa.bairro = dados.bairro;
            self.pessoa.cidade = dados.municipio;
            self.pessoa.estado = dados.estado;
            self.pessoa.numero = dados.numero;
            self.pessoa.complemento = dados.complemento;

            self.agendamento.nome = dados.nome;
            self.agendamento.cns = dados.codigoCNS;
            self.agendamento.cpf = dados.cpf;

            self.$message("Pessoa encontrada", dados.nome, "success");
          })
          .catch(() => {
            self.$message("Atenção!", "CPF não encontrado", "warning");
          });
      }
    },
    agendarConsulta: function () {
      const self = this;
      const api = self.$store.state.api + "agendamentos/";

      self.$loading(true);
      self.agendamento.nome = self.pessoa.nome;
      self.agendamento.status = 1;

      axios
        .post(api, self.agendamento)
        .then(() => {
          self.$message(
            "Sucesso",
            `Informações guardadas com sucesso`,
            "success"
          );

          self.$loading(false);
        })
        .catch((error) => {
          self.$loading(false);
          self.$message(null, error.response.data, "error");
        });
    },
    getSenhas: function () {
      const self = this;
      const api =
        self.$store.state.api +
        "atendimentos?paginated=false&with[]=pessoa&atendimento_id_pai=" +
        self.$route.params.id;

      self.$loading(true);

      axios
        .get(api)
        .then((response) => {
          self.atendimentos = response.data.data;

          self.getAllAtendimentos();
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    getAllAtendimentos: function () {
      const self = this;
      const api =
        self.$store.state.api +
        "atendimentos?paginated=false&whereNull=data_fim";

      axios
        .get(api)
        .then((response) => {
          self.allAtendimentos = response.data.data;

          self.$loading(false);
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    addSubsenha: function () {
      const self = this;
      const api = self.$store.state.api + "add-subsenha/" + self.subsenha;
      self.$loading(true);
      self.subsenhas = "";

      axios
        .post(api, { atendimento_id: self.$route.params.id })
        .then(() => {
          self.getSenhas();

          self.$loading(false);
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    removeSubsenha: function (id) {
      const self = this;
      const api = self.$store.state.api + "remove-subsenha/" + id;
      self.$loading(true);

      axios
        .post(api)
        .then(() => {
          self.getSenhas();

          self.subsenhas = "";

          self.$loading(false);
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    abreSubSenha: function () {
      const self = this;
      const api = self.$store.state.api + "cria_senha";

      axios
        .post(api, {
          botao_id: self.senha.min_atendimento.botao_id,
          cpf: "",
          prioridade: self.senha.prioridade,
          documento: [],
          impressora: "",
          setor_id: self.senha.setor_id,
        })
        .then((response) => {
          self.subsenha = response.data.id;

          self.addSubsenha();
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    async iniciarCamera() {
      try {
        const stream = await navigator.mediaDevices.getUserMedia({
          video: true,
        });
        this.$refs.video.srcObject = stream;
      } catch (error) {
        console.error("Erro ao acessar a câmera:", error);
      }
    },
    tirarFoto() {
      const video = this.$refs.video;
      const canvas = this.$refs.canvas;
      const context = canvas.getContext("2d");

      context.drawImage(video, 0, 0, canvas.width, canvas.height);
      this.fotoUrl = canvas.toDataURL("image/png");

      const self = this;
      const api = self.$store.state.api + "cadastramento-facial";

      self.pessoa.nome = self.pessoa.nome_social;
      self.pessoa.foto = self.fotoUrl;

      axios
        .post(api, self.pessoa)
        .then(() => {
          self.savePessoa();
          setTimeout(() => {
            if (
              self.senha.min_atendimento &&
              self.senha.min_atendimento.pessoa_id
            ) {
              self.getPessoa(self.senha.min_atendimento.pessoa_id);
            }
          }, 500);
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });

      this.fecharCamera();
    },
    fecharCamera() {
      if (this.stream) {
        this.stream.getTracks().forEach((track) => track.stop());
        this.stream = null;
        this.$refs.video.srcObject = null;
      }
    },
    changePrioridade: function () {
      const self = this;
      const api = self.$store.state.api + `troca-prioridade/${self.senha.id}`;
      self.$loading(true);

      axios
        .post(api, { prioridade: self.prioridade })
        .then(() => {
          self.senha.prioridade = self.prioridade;
          self.getSenha(self.senha.id);

          self.$message(
            "Sucesso",
            `Informações guardadas com sucesso`,
            "success"
          );
        })
        .catch((error) => {
          self.$message(null, error.response.data, "error");
        });
    },
    getEndereco: function () {
      var self = this;

      if (/^[0-9]{5}-[0-9]{3}$/.test(this.pessoa.cep)) {
        $.getJSON(
          "https://viacep.com.br/ws/" + this.pessoa.cep + "/json/",
          function (endereco) {
            if (endereco.erro) {
              self.endereco = {};

              return;
            }

            self.pessoa.cidade = endereco.localidade;
            self.pessoa.logradouro = endereco.logradouro;
            self.pessoa.bairro = endereco.bairro;
            self.pessoa.estado = endereco.uf;
          }
        );
      }
    },
    getFila: function () {
      $("#aresTriagemModal").modal("hide");
      this.$router.push("/chamador");
    },
    addExternoId: function () {
      const self = this;
      const api =
        self.$store.state.api + `externo-id/${self.senha.min_atendimento.id}`;
      self.$loading(true);

      axios
        .post(api, { externo_id: self.senha.min_atendimento.externo_id })
        .then(() => {
          self.$loading(false);

          self.$message(
            "Sucesso",
            `Informações guardadas com sucesso`,
            "success"
          );
        })
        .catch((error) => {
          self.$loading(false);
          self.$message(null, error.response.data, "error");
        });
    },
    getPath: function () {
      const self = this;
      const api =
        self.$store.state.api +
        `atendimento_setor?atendimento_id=${self.senha.min_atendimento.id}&with[]=setor&with[]=local&with[]=user`;
      self.$loading(true);

      axios
        .get(api)
        .then((response) => {
          self.senhaPath = response.data.data.reverse();

          self.$loading(false);
        })
        .catch((error) => {
          self.$loading(false);
          self.$message(null, error.response.data, "error");
        });
    },
    getTimelineIcon: function (atendimento) {
      if (atendimento.data_fim_f) {
        return "fa-check-circle";
      } else if (atendimento.data_inicio_f) {
        return "fa-hourglass-half";
      } else {
        return "fa-clock";
      }
    },
  },
  watch: {
    "$store.state.user.setor"(newVal, oldVal) {
      if (!newVal || newVal === oldVal) return;
      if (!oldVal) {
        // F5: setor chegou do /me, só carrega se ainda não foi preenchido
        if (!this.setores.length) this.getSetorAtual();
      } else {
        // Troca real de setor: limpa dados do setor anterior e recarrega
        this.setores = [];
        this.atual = {};
        this.getSetorAtual();
      }
    },
  },
  mounted: function () {
    const self = this;
    let id = self.$route.params.id;

    self.$loading(true);

    self.setLoader(25);

    self.getClassificacao();
    self.getFinalizacao();
    self.getConfiguracao();

    self.cooldown = true;

    setTimeout(() => {
      self.contagemRegressiva = self.configuracao.cooldown;

      let contagem = setInterval(() => {
        self.contagemRegressiva--;
      }, 1000);

      setTimeout(() => {
        self.cooldown = false;
        clearInterval(contagem);
      }, self.contagemRegressiva * 1000);
    }, 1000);

    if (id) {
      self.getSenha(id);
    }

    setTimeout(() => {
      if (
        self.senha.data_inicio &&
        self.atual.envia_ares_triagem &&
        self.configuracao.integra_ares_triagem
      ) {
        $("#aresTriagemModal").modal("toggle");
      }
    }, 2000);
  },

  beforeDestroy: function () {
    const self = this;
    clearInterval(self.contadorSetor);
    clearInterval(self.contadorInicio);
    clearInterval(self.contadorUnidade);
    clearInterval(self.contadorChamada);
  },

  components: {
    BaseCrud,
    vSelect,
  },
};
</script>
<style scoped>
.profile_user {
  text-align: center;
}

.photo {
  display: block;
  margin-left: 5px;
  width: 18%;
  border-radius: 10px;
  max-width: 400px;
  max-height: 400px;
  object-fit: cover;
}

.btn-user:hover,
.btn-user[aria-expanded="true"] {
  background: linear-gradient(to right, #000, #666);
  color: #fff !important;
}

.photo-title {
  color: #000;
  font-size: 18px;
  display: block;
  margin-left: 5px;
  width: 18%;
}

.rotating {
  -webkit-animation: rotating 2s linear infinite;
  -moz-animation: rotating 2s linear infinite;
  -ms-animation: rotating 2s linear infinite;
  -o-animation: rotating 2s linear infinite;
  animation: rotating 2s linear infinite;
}

.clocks:hover {
  transform: scale(1.05);
}

@-webkit-keyframes rotating

/* Safari and Chrome */ {
  from {
    -webkit-transform: rotate(0deg);
    -o-transform: rotate(0deg);
    transform: rotate(0deg);
  }

  to {
    -webkit-transform: rotate(360deg);
    -o-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}

@keyframes rotating {
  from {
    -ms-transform: rotate(0deg);
    -moz-transform: rotate(0deg);
    -webkit-transform: rotate(0deg);
    -o-transform: rotate(0deg);
    transform: rotate(0deg);
  }

  to {
    -ms-transform: rotate(360deg);
    -moz-transform: rotate(360deg);
    -webkit-transform: rotate(360deg);
    -o-transform: rotate(360deg);
    transform: rotate(360deg);
  }
}

.hover-white:hover {
  color: #eee;
}

.fadeOut {
  display: none;
  transition: opacity 1s ease-in-out;
}

/* Badge Prioridade Styles */
.badge-prioridade {
  display: inline-block;
  transition: all 0.3s ease;
}

.badge-prioridade:hover {
  transform: scale(1.05);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}

.badge-prioridade-disabled {
  display: inline-block;
  opacity: 0.8;
  cursor: default;
}

/* Info DateTime Card Styles */
.info-datetime-card {
  background: linear-gradient(135deg, #f8f9fa 0%, #ffffff 100%);
  border-radius: 0.5rem;
  padding: 1rem;
  margin-top: 1rem;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.info-datetime-item {
  display: flex;
  align-items: flex-start;
  padding: 0.5rem 0;
}

.info-datetime-item i {
  font-size: 1.25rem;
  margin-top: 0.25rem;
}

.info-datetime-item small {
  font-size: 0.75rem;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  color: #000000 !important;
  font-weight: 600;
}

.info-datetime-item h6 {
  color: #000000 !important;
  font-size: 0.95rem;
}

.info-datetime-divider {
  height: 1px;
  background: linear-gradient(90deg, transparent, #e9ecef, transparent);
  margin: 0.5rem 0;
}

/* Notas Section Styles */
.notas-container {
  border: none;
  box-shadow: 0 4px 24px 0 rgba(34, 41, 47, 0.1);
  border-radius: 0.428rem;
  overflow: hidden;
}

.notas-header {
  background: linear-gradient(135deg, #1e88e5 0%, #1565c0 100%);
  border: none;
  padding: 1rem 1.5rem;
  color: white;
}

.notas-header h5 {
  color: white;
  font-weight: 600;
}

.notas-header .badge-light-secondary {
  background-color: rgba(255, 255, 255, 0.2);
  color: white;
  font-size: 13px;
  padding: 0.4rem 0.75rem;
  font-weight: 600;
}

.notas-list {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.nota-item {
  animation: fadeInUp 0.4s ease-out;
}

.nota-card {
  background: #fff;
  border: 1px solid #e9ecef;
  border-radius: 0.5rem;
  padding: 1rem;
  transition: all 0.3s ease;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

.nota-card:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  transform: translateY(-2px);
  border-color: #1e88e5;
}

.nota-header-info {
  margin-bottom: 0.75rem;
  padding-bottom: 0.75rem;
  border-bottom: 1px solid #e9ecef;
}

.nota-author {
  font-weight: 600;
  color: #5e5873;
  font-size: 14px;
}

.nota-timestamp {
  font-size: 12px;
  color: #000000;
  margin-top: 2px;
}

.nota-content {
  padding-left: 0;
}

.nota-title {
  color: #1e88e5;
  font-weight: 600;
  margin-bottom: 0.5rem;
  font-size: 15px;
}

.nota-description {
  color: #6e6b7b;
  font-size: 14px;
  line-height: 1.6;
  word-wrap: break-word;
}

.b-avatar.badge-light-info {
  background-color: rgba(30, 136, 229, 0.12);
  color: #1e88e5;
  display: flex;
  align-items: center;
  justify-content: center;
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }

  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@media (max-width: 768px) {
  .notas-header {
    padding: 0.75rem 1rem;
  }

  .nota-card {
    padding: 0.75rem;
  }
}

/* Timeline Modal Styles */
.timeline-modal .modal-content {
  border: none;
  border-radius: 0.5rem;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.15);
}

.timeline-header {
  background: linear-gradient(135deg, #1e88e5 0%, #1565c0 100%);
  border: none;
  padding: 1.25rem 1.5rem;
  color: white;
  border-radius: 0.5rem 0.5rem 0 0;
}

.timeline-header h5 {
  color: white;
  font-weight: 600;
  font-size: 1.25rem;
}

.timeline-header .close {
  text-shadow: none;
  opacity: 1;
}

.timeline-body {
  padding: 2rem 1.5rem;
  background: #f8f9fa;
  max-height: 70vh;
  overflow-y: auto;
}

.timeline-container {
  position: relative;
}

.timeline-item {
  display: flex;
  position: relative;
  padding-bottom: 2rem;
}

.timeline-item:last-child {
  padding-bottom: 0;
}

.timeline-marker {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-right: 1.5rem;
}

.timeline-icon {
  width: 48px;
  height: 48px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  color: white;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15);
  z-index: 2;
  transition: all 0.3s ease;
}

.timeline-icon:hover {
  transform: scale(1.1);
}

.timeline-icon-success {
  background: linear-gradient(135deg, #28c76f 0%, #1ea758 100%);
}

.timeline-icon-warning {
  background: linear-gradient(135deg, #ff9f43 0%, #ff6b35 100%);
}

.timeline-icon-danger {
  background: linear-gradient(135deg, #ea5455 0%, #d63031 100%);
}

.timeline-icon-info {
  background: linear-gradient(135deg, #00cfe8 0%, #0396a6 100%);
}

.timeline-icon-secondary {
  background: linear-gradient(135deg, #82868b 0%, #6c757d 100%);
}

.timeline-icon-primary {
  background: linear-gradient(135deg, #1e88e5 0%, #1565c0 100%);
}

.timeline-line {
  width: 3px;
  flex: 1;
  background: linear-gradient(180deg, #1e88e5 0%, rgba(30, 136, 229, 0.3) 100%);
  margin-top: 0.5rem;
  border-radius: 2px;
}

.timeline-content {
  flex: 1;
  animation: slideInRight 0.5s ease-out;
}

.timeline-card {
  background: white;
  border-radius: 0.5rem;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
  overflow: hidden;
  transition: all 0.3s ease;
}

.timeline-card:hover {
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.12);
  transform: translateY(-2px);
}

.timeline-card-header {
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  padding: 1rem 1.25rem;
  border-bottom: 2px solid #1e88e5;
}

.timeline-setor {
  color: #5e5873;
  font-weight: 700;
  font-size: 1.1rem;
  margin-bottom: 0.25rem;
}

.timeline-local {
  color: #6e6b7b;
  font-size: 0.9rem;
  display: inline-block;
}

.timeline-badge {
  font-size: 0.85rem;
  padding: 0.4rem 0.75rem;
  font-weight: 600;
  border-radius: 0.25rem;
}

.timeline-card-body {
  padding: 1.25rem;
}

.timeline-info-item {
  display: flex;
  align-items: flex-start;
  margin-bottom: 1rem;
}

.timeline-info-item i {
  font-size: 1.25rem;
  margin-top: 0.25rem;
}

.timeline-info-item small {
  font-size: 0.75rem;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.timeline-timestamps {
  display: flex;
  justify-content: space-between;
  gap: 1rem;
  flex-wrap: wrap;
}

.timestamp-item {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  flex: 1;
  min-width: 120px;
}

.timestamp-item i {
  font-size: 1.25rem;
}

.timestamp-item div {
  display: flex;
  flex-direction: column;
}

.timestamp-item small {
  font-size: 0.7rem;
  color: #b9b9c3;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.timestamp-item span {
  font-size: 0.85rem;
  font-weight: 600;
  color: #5e5873;
}

@keyframes slideInRight {
  from {
    opacity: 0;
    transform: translateX(30px);
  }

  to {
    opacity: 1;
    transform: translateX(0);
  }
}

@media (max-width: 768px) {
  .timeline-body {
    padding: 1rem;
  }

  .timeline-marker {
    margin-right: 1rem;
  }

  .timeline-icon {
    width: 40px;
    height: 40px;
    font-size: 16px;
  }

  .timeline-setor {
    font-size: 1rem;
  }

  .timeline-card-body {
    padding: 1rem;
  }

  .timeline-timestamps {
    flex-direction: column;
  }

  .timestamp-item {
    min-width: 100%;
  }
}

/* Estilo para o botão pequeno de histórico */
.btn-crud {
  width: 32px;
  height: 32px;
  padding: 0;
  border-radius: 6px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
}

.btn-crud i {
  margin: 0;
}
</style>
